export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Money` scalar type represents monetary values and supports signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point). */
  Money: { input: any; output: any; }
  /** Uint8Array */
  Uint8Array: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AddDisputeProposalInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  disputeId: Scalars['ID']['input'];
  refundResolution?: InputMaybe<AddProposalRefundResolutionInput>;
};

export type AddProposalRefundResolutionInput = {
  adjustment?: InputMaybe<Scalars['Money']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export enum AdjustmentType {
  DISTRIBUTED_ORDER_PROMOTION = 'DISTRIBUTED_ORDER_PROMOTION',
  OTHER = 'OTHER',
  PROMOTION = 'PROMOTION'
}

export enum AssetType {
  BINARY = 'BINARY',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export type AuthenticationInput = {
  native?: InputMaybe<NativeAuthInput>;
};

/** Operators for filtering on a list of Boolean fields */
export type BooleanListOperators = {
  inList: Scalars['Boolean']['input'];
};

/** Operators for filtering on a Boolean field */
export type BooleanOperators = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionFilterParameter = {
  _and?: InputMaybe<Array<CollectionFilterParameter>>;
  _or?: InputMaybe<Array<CollectionFilterParameter>>;
  count?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  parentId?: InputMaybe<IdOperators>;
  position?: InputMaybe<NumberOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CollectionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CollectionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CollectionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
  topLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionSortParameter = {
  count?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ComgateTransactionStatus {
  AUTHORIZED = 'AUTHORIZED',
  CANCELLED = 'CANCELLED',
  PAID = 'PAID',
  PENDING = 'PENDING'
}

export type ConfigArgInput = {
  name: Scalars['String']['input'];
  /** A JSON stringified representation of the actual value */
  value: Scalars['String']['input'];
};

export type ConfigurableOperationInput = {
  arguments: Array<ConfigArgInput>;
  code: Scalars['String']['input'];
};

/**
 * Input used to create an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type CreateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  file: Scalars['Upload']['input'];
};

export type CreateComgatePaymentInput = {
  /**
   * The URL to which the user should be redirected if the payment is cancelled.
   * example: 'http://frontend.url/redirect/cancelled?transId=${id}&refId=${refId}'
   */
  redirectUrlCancelled?: InputMaybe<Scalars['String']['input']>;
  /**
   * The URL to which the user should be redirected after the payment is completed.
   * example: 'http://frontend.url/redirect/paid?transId=${id}&refId=${refId}'
   */
  redirectUrlPaid?: InputMaybe<Scalars['String']['input']>;
  /**
   * The URL to which the user should be redirected if the payment is pending.
   * example: 'http://frontend.url/redirect/pending?transId=${id}&refId=${refId}'
   */
  redirectUrlPending?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDisputeInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  orderLineId: Scalars['ID']['input'];
  orderLineQuantity: Scalars['Int']['input'];
  reason: DisputeReason;
  refundResolution?: InputMaybe<AddProposalRefundResolutionInput>;
};

export type CreateProductReviewAssetInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  file: Scalars['Upload']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateProductReviewInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  authorLocation?: InputMaybe<Scalars['String']['input']>;
  authorName: Scalars['String']['input'];
  body: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCode;
  productId: Scalars['ID']['input'];
  rating: Scalars['Float']['input'];
  summary: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * @description
 * ISO 4217 currency code
 *
 * @docsCategory common
 */
export enum CurrencyCode {
  /** United Arab Emirates dirham */
  AED = 'AED',
  /** Afghan afghani */
  AFN = 'AFN',
  /** Albanian lek */
  ALL = 'ALL',
  /** Armenian dram */
  AMD = 'AMD',
  /** Netherlands Antillean guilder */
  ANG = 'ANG',
  /** Angolan kwanza */
  AOA = 'AOA',
  /** Argentine peso */
  ARS = 'ARS',
  /** Australian dollar */
  AUD = 'AUD',
  /** Aruban florin */
  AWG = 'AWG',
  /** Azerbaijani manat */
  AZN = 'AZN',
  /** Bosnia and Herzegovina convertible mark */
  BAM = 'BAM',
  /** Barbados dollar */
  BBD = 'BBD',
  /** Bangladeshi taka */
  BDT = 'BDT',
  /** Bulgarian lev */
  BGN = 'BGN',
  /** Bahraini dinar */
  BHD = 'BHD',
  /** Burundian franc */
  BIF = 'BIF',
  /** Bermudian dollar */
  BMD = 'BMD',
  /** Brunei dollar */
  BND = 'BND',
  /** Boliviano */
  BOB = 'BOB',
  /** Brazilian real */
  BRL = 'BRL',
  /** Bahamian dollar */
  BSD = 'BSD',
  /** Bhutanese ngultrum */
  BTN = 'BTN',
  /** Botswana pula */
  BWP = 'BWP',
  /** Belarusian ruble */
  BYN = 'BYN',
  /** Belize dollar */
  BZD = 'BZD',
  /** Canadian dollar */
  CAD = 'CAD',
  /** Congolese franc */
  CDF = 'CDF',
  /** Swiss franc */
  CHF = 'CHF',
  /** Chilean peso */
  CLP = 'CLP',
  /** Renminbi (Chinese) yuan */
  CNY = 'CNY',
  /** Colombian peso */
  COP = 'COP',
  /** Costa Rican colon */
  CRC = 'CRC',
  /** Cuban convertible peso */
  CUC = 'CUC',
  /** Cuban peso */
  CUP = 'CUP',
  /** Cape Verde escudo */
  CVE = 'CVE',
  /** Czech koruna */
  CZK = 'CZK',
  /** Djiboutian franc */
  DJF = 'DJF',
  /** Danish krone */
  DKK = 'DKK',
  /** Dominican peso */
  DOP = 'DOP',
  /** Algerian dinar */
  DZD = 'DZD',
  /** Egyptian pound */
  EGP = 'EGP',
  /** Eritrean nakfa */
  ERN = 'ERN',
  /** Ethiopian birr */
  ETB = 'ETB',
  /** Euro */
  EUR = 'EUR',
  /** Fiji dollar */
  FJD = 'FJD',
  /** Falkland Islands pound */
  FKP = 'FKP',
  /** Pound sterling */
  GBP = 'GBP',
  /** Georgian lari */
  GEL = 'GEL',
  /** Ghanaian cedi */
  GHS = 'GHS',
  /** Gibraltar pound */
  GIP = 'GIP',
  /** Gambian dalasi */
  GMD = 'GMD',
  /** Guinean franc */
  GNF = 'GNF',
  /** Guatemalan quetzal */
  GTQ = 'GTQ',
  /** Guyanese dollar */
  GYD = 'GYD',
  /** Hong Kong dollar */
  HKD = 'HKD',
  /** Honduran lempira */
  HNL = 'HNL',
  /** Croatian kuna */
  HRK = 'HRK',
  /** Haitian gourde */
  HTG = 'HTG',
  /** Hungarian forint */
  HUF = 'HUF',
  /** Indonesian rupiah */
  IDR = 'IDR',
  /** Israeli new shekel */
  ILS = 'ILS',
  /** Indian rupee */
  INR = 'INR',
  /** Iraqi dinar */
  IQD = 'IQD',
  /** Iranian rial */
  IRR = 'IRR',
  /** Icelandic króna */
  ISK = 'ISK',
  /** Jamaican dollar */
  JMD = 'JMD',
  /** Jordanian dinar */
  JOD = 'JOD',
  /** Japanese yen */
  JPY = 'JPY',
  /** Kenyan shilling */
  KES = 'KES',
  /** Kyrgyzstani som */
  KGS = 'KGS',
  /** Cambodian riel */
  KHR = 'KHR',
  /** Comoro franc */
  KMF = 'KMF',
  /** North Korean won */
  KPW = 'KPW',
  /** South Korean won */
  KRW = 'KRW',
  /** Kuwaiti dinar */
  KWD = 'KWD',
  /** Cayman Islands dollar */
  KYD = 'KYD',
  /** Kazakhstani tenge */
  KZT = 'KZT',
  /** Lao kip */
  LAK = 'LAK',
  /** Lebanese pound */
  LBP = 'LBP',
  /** Sri Lankan rupee */
  LKR = 'LKR',
  /** Liberian dollar */
  LRD = 'LRD',
  /** Lesotho loti */
  LSL = 'LSL',
  /** Libyan dinar */
  LYD = 'LYD',
  /** Moroccan dirham */
  MAD = 'MAD',
  /** Moldovan leu */
  MDL = 'MDL',
  /** Malagasy ariary */
  MGA = 'MGA',
  /** Macedonian denar */
  MKD = 'MKD',
  /** Myanmar kyat */
  MMK = 'MMK',
  /** Mongolian tögrög */
  MNT = 'MNT',
  /** Macanese pataca */
  MOP = 'MOP',
  /** Mauritanian ouguiya */
  MRU = 'MRU',
  /** Mauritian rupee */
  MUR = 'MUR',
  /** Maldivian rufiyaa */
  MVR = 'MVR',
  /** Malawian kwacha */
  MWK = 'MWK',
  /** Mexican peso */
  MXN = 'MXN',
  /** Malaysian ringgit */
  MYR = 'MYR',
  /** Mozambican metical */
  MZN = 'MZN',
  /** Namibian dollar */
  NAD = 'NAD',
  /** Nigerian naira */
  NGN = 'NGN',
  /** Nicaraguan córdoba */
  NIO = 'NIO',
  /** Norwegian krone */
  NOK = 'NOK',
  /** Nepalese rupee */
  NPR = 'NPR',
  /** New Zealand dollar */
  NZD = 'NZD',
  /** Omani rial */
  OMR = 'OMR',
  /** Panamanian balboa */
  PAB = 'PAB',
  /** Peruvian sol */
  PEN = 'PEN',
  /** Papua New Guinean kina */
  PGK = 'PGK',
  /** Philippine peso */
  PHP = 'PHP',
  /** Pakistani rupee */
  PKR = 'PKR',
  /** Polish złoty */
  PLN = 'PLN',
  /** Paraguayan guaraní */
  PYG = 'PYG',
  /** Qatari riyal */
  QAR = 'QAR',
  /** Romanian leu */
  RON = 'RON',
  /** Serbian dinar */
  RSD = 'RSD',
  /** Russian ruble */
  RUB = 'RUB',
  /** Rwandan franc */
  RWF = 'RWF',
  /** Saudi riyal */
  SAR = 'SAR',
  /** Solomon Islands dollar */
  SBD = 'SBD',
  /** Seychelles rupee */
  SCR = 'SCR',
  /** Sudanese pound */
  SDG = 'SDG',
  /** Swedish krona/kronor */
  SEK = 'SEK',
  /** Singapore dollar */
  SGD = 'SGD',
  /** Saint Helena pound */
  SHP = 'SHP',
  /** Sierra Leonean leone */
  SLL = 'SLL',
  /** Somali shilling */
  SOS = 'SOS',
  /** Surinamese dollar */
  SRD = 'SRD',
  /** South Sudanese pound */
  SSP = 'SSP',
  /** São Tomé and Príncipe dobra */
  STN = 'STN',
  /** Salvadoran colón */
  SVC = 'SVC',
  /** Syrian pound */
  SYP = 'SYP',
  /** Swazi lilangeni */
  SZL = 'SZL',
  /** Thai baht */
  THB = 'THB',
  /** Tajikistani somoni */
  TJS = 'TJS',
  /** Turkmenistan manat */
  TMT = 'TMT',
  /** Tunisian dinar */
  TND = 'TND',
  /** Tongan paʻanga */
  TOP = 'TOP',
  /** Turkish lira */
  TRY = 'TRY',
  /** Trinidad and Tobago dollar */
  TTD = 'TTD',
  /** New Taiwan dollar */
  TWD = 'TWD',
  /** Tanzanian shilling */
  TZS = 'TZS',
  /** Ukrainian hryvnia */
  UAH = 'UAH',
  /** Ugandan shilling */
  UGX = 'UGX',
  /** United States dollar */
  USD = 'USD',
  /** Uruguayan peso */
  UYU = 'UYU',
  /** Uzbekistan som */
  UZS = 'UZS',
  /** Venezuelan bolívar soberano */
  VES = 'VES',
  /** Vietnamese đồng */
  VND = 'VND',
  /** Vanuatu vatu */
  VUV = 'VUV',
  /** Samoan tala */
  WST = 'WST',
  /** CFA franc BEAC */
  XAF = 'XAF',
  /** East Caribbean dollar */
  XCD = 'XCD',
  /** CFA franc BCEAO */
  XOF = 'XOF',
  /** CFP franc (franc Pacifique) */
  XPF = 'XPF',
  /** Yemeni rial */
  YER = 'YER',
  /** South African rand */
  ZAR = 'ZAR',
  /** Zambian kwacha */
  ZMW = 'ZMW',
  /** Zimbabwean dollar */
  ZWL = 'ZWL'
}

export type CustomerFilterParameter = {
  _and?: InputMaybe<Array<CustomerFilterParameter>>;
  _or?: InputMaybe<Array<CustomerFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  emailAddress?: InputMaybe<StringOperators>;
  firstName?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  lastName?: InputMaybe<StringOperators>;
  phoneNumber?: InputMaybe<StringOperators>;
  title?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CustomerListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CustomerFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CustomerSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  emailAddress?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** Operators for filtering on a list of Date fields */
export type DateListOperators = {
  inList: Scalars['DateTime']['input'];
};

/** Operators for filtering on a DateTime field */
export type DateOperators = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  between?: InputMaybe<DateRange>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateRange = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export enum DeletionResult {
  /** The entity was successfully deleted */
  DELETED = 'DELETED',
  /** Deletion did not take place, reason given in message */
  NOT_DELETED = 'NOT_DELETED'
}

export enum DisputeEscalationLevel {
  AdminArbitration = 'AdminArbitration',
  CustomerSeller = 'CustomerSeller',
  LegalArbitration = 'LegalArbitration'
}

export type DisputeFilterParameter = {
  _and?: InputMaybe<Array<DisputeFilterParameter>>;
  _or?: InputMaybe<Array<DisputeFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  escalationLevel?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  reason?: InputMaybe<StringOperators>;
  reasonName?: InputMaybe<StringOperators>;
  state?: InputMaybe<StringOperators>;
  stateName?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  verdict?: InputMaybe<StringOperators>;
};

export type DisputeListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<DisputeFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<DisputeSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export enum DisputeMessageType {
  Evidence = 'Evidence',
  Text = 'Text'
}

export type DisputeProposalFilterParameter = {
  _and?: InputMaybe<Array<DisputeProposalFilterParameter>>;
  _or?: InputMaybe<Array<DisputeProposalFilterParameter>>;
  comment?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  state?: InputMaybe<StringOperators>;
  stateName?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type DisputeProposalListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<DisputeProposalFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<DisputeProposalSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type DisputeProposalSortParameter = {
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  stateName?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DisputeProposalState {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

/** Enumerates the reasons for an RMA dispute, specifying whether the product was not received or received. */
export enum DisputeReason {
  CanceledOrderBeforeShipment = 'CanceledOrderBeforeShipment',
  DamageDuringShipping = 'DamageDuringShipping',
  GoodsTakenByCustoms = 'GoodsTakenByCustoms',
  ItIsOverDeliveryTime = 'ItIsOverDeliveryTime',
  ItemArrivedLate = 'ItemArrivedLate',
  ItemNotReceived = 'ItemNotReceived',
  MissingPartsInTheProduct = 'MissingPartsInTheProduct',
  NotSatisfiedWithTheProduct = 'NotSatisfiedWithTheProduct',
  OtherIssues = 'OtherIssues',
  PackageIsHoldInCustoms = 'PackageIsHoldInCustoms',
  PackageIsReturnedToSellerByShippingCompany = 'PackageIsReturnedToSellerByShippingCompany',
  PackageIsShipToAWrongAddress = 'PackageIsShipToAWrongAddress',
  ProductDoesntMatchDescription = 'ProductDoesntMatchDescription',
  ProductDoesntWorkOrIsIncompatible = 'ProductDoesntWorkOrIsIncompatible',
  ProductHasABadSmell = 'ProductHasABadSmell',
  ProductInWorseConditionThanDescribed = 'ProductInWorseConditionThanDescribed',
  ProductIsDamaged = 'ProductIsDamaged',
  ProductIsDamagedInTransit = 'ProductIsDamagedInTransit',
  ProductIsDamagedOrFaulty = 'ProductIsDamagedOrFaulty',
  ProductIsMissingParts = 'ProductIsMissingParts',
  ProductIsNotAsDescribed = 'ProductIsNotAsDescribed',
  ProductLooksFakeOrCounterfeit = 'ProductLooksFakeOrCounterfeit',
  ProductWithQualityIssue = 'ProductWithQualityIssue',
  ReceivedFewerItemsThanOrdered = 'ReceivedFewerItemsThanOrdered',
  ThereIsNoTrackingInformation = 'ThereIsNoTrackingInformation',
  UnauthorizedPayment = 'UnauthorizedPayment',
  WrongColorReceived = 'WrongColorReceived',
  WrongSizeReceived = 'WrongSizeReceived'
}

export type DisputeSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  reasonName?: InputMaybe<SortOrder>;
  stateName?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum DisputeState {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Created = 'Created',
  PendingCustomerAction = 'PendingCustomerAction',
  PendingSellerAction = 'PendingSellerAction'
}

export enum DisputeType {
  /**
   * Dispute type: Product not received.
   * Haven't received your order:
   * It's over delivery time;
   * There is no tracking information;
   * Package is returned to seller by shipping company;
   * Package is hold in customs;
   * Package is ship to a wrong address;
   */
  ProductNotReceived = 'ProductNotReceived',
  /**
   * Dispute type: Product received.
   * Products received, but seller cannot help to solve the product issue (pls contact seller first):
   * Product with quality issue;
   * Product is not as described;
   * Product is damaged;
   * Product is damaged in transit;
   * Product is missing parts;
   * Other issues;
   */
  ProductReceived = 'ProductReceived'
}

/** Enumerates the possible verdicts/outcomes for an RMA dispute. */
export enum DisputeVerdict {
  Canceled = 'Canceled',
  Fraud = 'Fraud',
  Other = 'Other',
  Refund = 'Refund',
  TimeOut = 'TimeOut'
}

export enum ErrorCode {
  ACTIVE_DISPUTE_PROPOSAL_ALREADY_EXIST_ERROR = 'ACTIVE_DISPUTE_PROPOSAL_ALREADY_EXIST_ERROR',
  ALREADY_LOGGED_IN_ERROR = 'ALREADY_LOGGED_IN_ERROR',
  COUPON_CODE_EXPIRED_ERROR = 'COUPON_CODE_EXPIRED_ERROR',
  COUPON_CODE_INVALID_ERROR = 'COUPON_CODE_INVALID_ERROR',
  COUPON_CODE_LIMIT_ERROR = 'COUPON_CODE_LIMIT_ERROR',
  CREATE_PRODUCT_REVIEW_ERROR = 'CREATE_PRODUCT_REVIEW_ERROR',
  CUSTOMER_NOT_FOUND_ERROR = 'CUSTOMER_NOT_FOUND_ERROR',
  DISPUTE_ALREADY_EXIST_ERROR = 'DISPUTE_ALREADY_EXIST_ERROR',
  DISPUTE_NOT_FOUND_ERROR = 'DISPUTE_NOT_FOUND_ERROR',
  DISPUTE_PROPOSAL_STATE_TRANSITION_ERROR = 'DISPUTE_PROPOSAL_STATE_TRANSITION_ERROR',
  DISPUTE_STATE_TRANSITION_ERROR = 'DISPUTE_STATE_TRANSITION_ERROR',
  EMAIL_ADDRESS_CONFLICT_ERROR = 'EMAIL_ADDRESS_CONFLICT_ERROR',
  GUEST_CHECKOUT_ERROR = 'GUEST_CHECKOUT_ERROR',
  IDENTIFIER_CHANGE_TOKEN_EXPIRED_ERROR = 'IDENTIFIER_CHANGE_TOKEN_EXPIRED_ERROR',
  IDENTIFIER_CHANGE_TOKEN_INVALID_ERROR = 'IDENTIFIER_CHANGE_TOKEN_INVALID_ERROR',
  INELIGIBLE_PAYMENT_METHOD_ERROR = 'INELIGIBLE_PAYMENT_METHOD_ERROR',
  INELIGIBLE_SHIPPING_METHOD_ERROR = 'INELIGIBLE_SHIPPING_METHOD_ERROR',
  INSUFFICIENT_STOCK_ERROR = 'INSUFFICIENT_STOCK_ERROR',
  INTERNAL_ORACLE_ERROR = 'INTERNAL_ORACLE_ERROR',
  INVALID_CREDENTIALS_ERROR = 'INVALID_CREDENTIALS_ERROR',
  MIME_TYPE_ERROR = 'MIME_TYPE_ERROR',
  MISSING_PASSWORD_ERROR = 'MISSING_PASSWORD_ERROR',
  NATIVE_AUTH_STRATEGY_ERROR = 'NATIVE_AUTH_STRATEGY_ERROR',
  NEGATIVE_QUANTITY_ERROR = 'NEGATIVE_QUANTITY_ERROR',
  NOT_VERIFIED_ERROR = 'NOT_VERIFIED_ERROR',
  NO_ACTIVE_ORDER_ERROR = 'NO_ACTIVE_ORDER_ERROR',
  ORDER_HAS_NOT_FULFILLMENTS_ERROR = 'ORDER_HAS_NOT_FULFILLMENTS_ERROR',
  ORDER_HAS_NO_VALID_FULFILLMENTS_ERROR = 'ORDER_HAS_NO_VALID_FULFILLMENTS_ERROR',
  ORDER_INTERCEPTOR_ERROR = 'ORDER_INTERCEPTOR_ERROR',
  ORDER_LIMIT_ERROR = 'ORDER_LIMIT_ERROR',
  ORDER_LINE_NOT_FOUND_ERROR = 'ORDER_LINE_NOT_FOUND_ERROR',
  ORDER_MODIFICATION_ERROR = 'ORDER_MODIFICATION_ERROR',
  ORDER_PAYMENT_STATE_ERROR = 'ORDER_PAYMENT_STATE_ERROR',
  ORDER_STATE_TRANSITION_ERROR = 'ORDER_STATE_TRANSITION_ERROR',
  PASSWORD_ALREADY_SET_ERROR = 'PASSWORD_ALREADY_SET_ERROR',
  PASSWORD_RESET_TOKEN_EXPIRED_ERROR = 'PASSWORD_RESET_TOKEN_EXPIRED_ERROR',
  PASSWORD_RESET_TOKEN_INVALID_ERROR = 'PASSWORD_RESET_TOKEN_INVALID_ERROR',
  PASSWORD_VALIDATION_ERROR = 'PASSWORD_VALIDATION_ERROR',
  PAYMENT_DECLINED_ERROR = 'PAYMENT_DECLINED_ERROR',
  PAYMENT_FAILED_ERROR = 'PAYMENT_FAILED_ERROR',
  PRODUCT_REVIEW_ASSET_MIME_TYPE_ERROR = 'PRODUCT_REVIEW_ASSET_MIME_TYPE_ERROR',
  REVIEW_AUTHOR_NOT_FOUND = 'REVIEW_AUTHOR_NOT_FOUND',
  REVIEW_BODY_TOO_LONG = 'REVIEW_BODY_TOO_LONG',
  REVIEW_BODY_TOO_SHORT = 'REVIEW_BODY_TOO_SHORT',
  REVIEW_PRODUCT_NOT_FOUND = 'REVIEW_PRODUCT_NOT_FOUND',
  REVIEW_PRODUCT_VARIANT_NOT_FOUND = 'REVIEW_PRODUCT_VARIANT_NOT_FOUND',
  REVIEW_SUMMARY_TOO_LONG = 'REVIEW_SUMMARY_TOO_LONG',
  REVIEW_SUMMARY_TOO_SHORT = 'REVIEW_SUMMARY_TOO_SHORT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNSUPPORTED_COUNTRY_CODE_ERROR = 'UNSUPPORTED_COUNTRY_CODE_ERROR',
  VERIFICATION_TOKEN_EXPIRED_ERROR = 'VERIFICATION_TOKEN_EXPIRED_ERROR',
  VERIFICATION_TOKEN_INVALID_ERROR = 'VERIFICATION_TOKEN_INVALID_ERROR'
}

export type FacetFilterParameter = {
  _and?: InputMaybe<Array<FacetFilterParameter>>;
  _or?: InputMaybe<Array<FacetFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FacetListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FacetFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FacetSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FacetSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/**
 * Used to construct boolean expressions for filtering search results
 * by FacetValue ID. Examples:
 *
 * * ID=1 OR ID=2: `{ facetValueFilters: [{ or: [1,2] }] }`
 * * ID=1 AND ID=2: `{ facetValueFilters: [{ and: 1 }, { and: 2 }] }`
 * * ID=1 AND (ID=2 OR ID=3): `{ facetValueFilters: [{ and: 1 }, { or: [2,3] }] }`
 */
export type FacetValueFilterInput = {
  and?: InputMaybe<Scalars['ID']['input']>;
  /** default is true, and by default it will filter by product facet values */
  byProduct?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FacetValueFilterParameter = {
  _and?: InputMaybe<Array<FacetValueFilterParameter>>;
  _or?: InputMaybe<Array<FacetValueFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  count?: InputMaybe<NumberOperators>;
  createdAt?: InputMaybe<DateOperators>;
  facetId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FacetValueListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FacetValueFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FacetValueSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FacetValueSortParameter = {
  code?: InputMaybe<SortOrder>;
  count?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  facetId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum GcxAudioEncoding {
  AUDIO_ENCODING_AMR = 'AUDIO_ENCODING_AMR',
  AUDIO_ENCODING_AMR_WB = 'AUDIO_ENCODING_AMR_WB',
  AUDIO_ENCODING_FLAC = 'AUDIO_ENCODING_FLAC',
  AUDIO_ENCODING_LINEAR_16 = 'AUDIO_ENCODING_LINEAR_16',
  AUDIO_ENCODING_MULAW = 'AUDIO_ENCODING_MULAW',
  AUDIO_ENCODING_OGG_OPUS = 'AUDIO_ENCODING_OGG_OPUS',
  AUDIO_ENCODING_SPEEX_WITH_HEADER_BYTE = 'AUDIO_ENCODING_SPEEX_WITH_HEADER_BYTE',
  AUDIO_ENCODING_UNSPECIFIED = 'AUDIO_ENCODING_UNSPECIFIED'
}

export type GcxAudioInput = {
  audio?: InputMaybe<Scalars['String']['input']>;
  config: GcxInputAudioConfig;
};

export enum GcxAutoExpansionMode {
  AUTO_EXPANSION_MODE_DEFAULT = 'AUTO_EXPANSION_MODE_DEFAULT',
  AUTO_EXPANSION_MODE_UNSPECIFIED = 'AUTO_EXPANSION_MODE_UNSPECIFIED'
}

export type GcxDetectIntentRequest = {
  outputAudioConfig?: InputMaybe<GcxOutputAudioConfigInput>;
  queryInput: GcxQueryInput;
  queryParams?: InputMaybe<GcxQueryParameters>;
  session: Scalars['String']['input'];
};

export type GcxDtmfInputInput = {
  digits?: InputMaybe<Scalars['String']['input']>;
  finishDigit?: InputMaybe<Scalars['String']['input']>;
};

export type GcxDuration = {
  nanos?: InputMaybe<Scalars['Int']['input']>;
  seconds?: InputMaybe<Scalars['Int']['input']>;
};

export enum GcxEntityOverrideMode {
  ENTITY_OVERRIDE_MODE_OVERRIDE = 'ENTITY_OVERRIDE_MODE_OVERRIDE',
  ENTITY_OVERRIDE_MODE_SUPPLEMENT = 'ENTITY_OVERRIDE_MODE_SUPPLEMENT',
  ENTITY_OVERRIDE_MODE_UNSPECIFIED = 'ENTITY_OVERRIDE_MODE_UNSPECIFIED'
}

export type GcxEntityType = {
  autoExpansionMode?: InputMaybe<GcxAutoExpansionMode>;
  displayName: Scalars['String']['input'];
  enableFuzzyExtraction?: InputMaybe<Scalars['Boolean']['input']>;
  entities?: InputMaybe<Array<InputMaybe<GcxEntityTypeEntity>>>;
  excludedPhrases?: InputMaybe<Array<InputMaybe<GcxEntityTypeExcludedPhrase>>>;
  kind: GcxKind;
  name?: InputMaybe<Scalars['String']['input']>;
  redact?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GcxEntityTypeEntity = {
  synonyms: Array<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type GcxEntityTypeExcludedPhrase = {
  value: Scalars['String']['input'];
};

export type GcxEventInput = {
  event?: InputMaybe<Scalars['String']['input']>;
};

export type GcxInputAudioConfig = {
  audioEncoding: GcxAudioEncoding;
  enableWordInfo?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelVariant?: InputMaybe<GcxSpeechModelVariant>;
  phraseHints?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sampleRateHertz?: InputMaybe<Scalars['Int']['input']>;
  singleUtterance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GcxIntentInput = {
  intent: Scalars['String']['input'];
};

export enum GcxKind {
  KIND_LIST = 'KIND_LIST',
  KIND_MAP = 'KIND_MAP',
  KIND_REGEXP = 'KIND_REGEXP',
  KIND_UNSPECIFIED = 'KIND_UNSPECIFIED'
}

export type GcxLatLng = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type GcxListValue = {
  values?: InputMaybe<Array<InputMaybe<GcxValue>>>;
};

export enum GcxMatchType {
  DIRECT_INTENT = 'DIRECT_INTENT',
  EVENT = 'EVENT',
  INTENT = 'INTENT',
  MATCH_TYPE_UNSPECIFIED = 'MATCH_TYPE_UNSPECIFIED',
  NO_INPUT = 'NO_INPUT',
  NO_MATCH = 'NO_MATCH',
  PARAMETER_FILLING = 'PARAMETER_FILLING'
}

export enum GcxNullValue {
  NULL_VALUE = 'NULL_VALUE'
}

export type GcxOutputAudioConfigInput = {
  audioEncoding: GcxOutputAudioEncoding;
  sampleRateHertz?: InputMaybe<Scalars['Int']['input']>;
  synthesizeSpeechConfig?: InputMaybe<GcxSynthesizeSpeechConfigInput>;
};

export enum GcxOutputAudioEncoding {
  OUTPUT_AUDIO_ENCODING_LINEAR_16 = 'OUTPUT_AUDIO_ENCODING_LINEAR_16',
  OUTPUT_AUDIO_ENCODING_MP3 = 'OUTPUT_AUDIO_ENCODING_MP3',
  OUTPUT_AUDIO_ENCODING_MP3_64_KBPS = 'OUTPUT_AUDIO_ENCODING_MP3_64_KBPS',
  OUTPUT_AUDIO_ENCODING_MULAW = 'OUTPUT_AUDIO_ENCODING_MULAW',
  OUTPUT_AUDIO_ENCODING_OGG_OPUS = 'OUTPUT_AUDIO_ENCODING_OGG_OPUS',
  OUTPUT_AUDIO_ENCODING_UNSPECIFIED = 'OUTPUT_AUDIO_ENCODING_UNSPECIFIED'
}

export type GcxQueryInput = {
  audio?: InputMaybe<GcxAudioInput>;
  dtmf?: InputMaybe<GcxDtmfInputInput>;
  event?: InputMaybe<GcxEventInput>;
  intent?: InputMaybe<GcxIntentInput>;
  languageCode: Scalars['String']['input'];
  text?: InputMaybe<GcxTextInput>;
};

export type GcxQueryParameters = {
  analyzeQueryTextSentiment?: InputMaybe<Scalars['Boolean']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  currentPage?: InputMaybe<Scalars['String']['input']>;
  disableWebhook?: InputMaybe<Scalars['Boolean']['input']>;
  flowVersions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  geoLocation?: InputMaybe<GcxLatLng>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  sessionEntityTypes?: InputMaybe<Array<InputMaybe<GcxSessionEntityType>>>;
  sessionTtl?: InputMaybe<GcxDuration>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  webhookHeaders?: InputMaybe<Scalars['JSON']['input']>;
};

export enum GcxResponseType {
  FINAL = 'FINAL',
  PARTIAL = 'PARTIAL',
  RESPONSE_TYPE_UNSPECIFIED = 'RESPONSE_TYPE_UNSPECIFIED'
}

export type GcxSessionEntityType = {
  entities: Array<GcxEntityTypeEntity>;
  entityOverrideMode: GcxEntityOverrideMode;
  name: Scalars['String']['input'];
};

export enum GcxSpeechModelVariant {
  SPEECH_MODEL_VARIANT_UNSPECIFIED = 'SPEECH_MODEL_VARIANT_UNSPECIFIED',
  USE_BEST_AVAILABLE = 'USE_BEST_AVAILABLE',
  USE_ENHANCED = 'USE_ENHANCED',
  USE_STANDARD = 'USE_STANDARD'
}

export enum GcxSsmlVoiceGender {
  SSML_VOICE_GENDER_FEMALE = 'SSML_VOICE_GENDER_FEMALE',
  SSML_VOICE_GENDER_MALE = 'SSML_VOICE_GENDER_MALE',
  SSML_VOICE_GENDER_NEUTRAL = 'SSML_VOICE_GENDER_NEUTRAL',
  SSML_VOICE_GENDER_UNSPECIFIED = 'SSML_VOICE_GENDER_UNSPECIFIED'
}

export type GcxSynthesizeSpeechConfigInput = {
  effectsProfileId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pitch?: InputMaybe<Scalars['Float']['input']>;
  speakingRate?: InputMaybe<Scalars['Float']['input']>;
  voice?: InputMaybe<GcxVoiceSelectionParamsInput>;
  volumeGainDb?: InputMaybe<Scalars['Float']['input']>;
};

export type GcxTextInput = {
  text: Scalars['String']['input'];
};

export type GcxValue = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  listValue?: InputMaybe<GcxListValue>;
  nullValue?: InputMaybe<GcxNullValue>;
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  structValue?: InputMaybe<Scalars['JSON']['input']>;
};

export type GcxVoiceSelectionParamsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  ssmlGender?: InputMaybe<GcxSsmlVoiceGender>;
};

export enum GlobalFlag {
  FALSE = 'FALSE',
  INHERIT = 'INHERIT',
  TRUE = 'TRUE'
}

export type HistoryEntryFilterParameter = {
  _and?: InputMaybe<Array<HistoryEntryFilterParameter>>;
  _or?: InputMaybe<Array<HistoryEntryFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type HistoryEntryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<HistoryEntryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<HistoryEntrySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type HistoryEntrySortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum HistoryEntryType {
  CUSTOMER_ADDED_TO_GROUP = 'CUSTOMER_ADDED_TO_GROUP',
  CUSTOMER_ADDRESS_CREATED = 'CUSTOMER_ADDRESS_CREATED',
  CUSTOMER_ADDRESS_DELETED = 'CUSTOMER_ADDRESS_DELETED',
  CUSTOMER_ADDRESS_UPDATED = 'CUSTOMER_ADDRESS_UPDATED',
  CUSTOMER_DETAIL_UPDATED = 'CUSTOMER_DETAIL_UPDATED',
  CUSTOMER_EMAIL_UPDATE_REQUESTED = 'CUSTOMER_EMAIL_UPDATE_REQUESTED',
  CUSTOMER_EMAIL_UPDATE_VERIFIED = 'CUSTOMER_EMAIL_UPDATE_VERIFIED',
  CUSTOMER_NOTE = 'CUSTOMER_NOTE',
  CUSTOMER_PASSWORD_RESET_REQUESTED = 'CUSTOMER_PASSWORD_RESET_REQUESTED',
  CUSTOMER_PASSWORD_RESET_VERIFIED = 'CUSTOMER_PASSWORD_RESET_VERIFIED',
  CUSTOMER_PASSWORD_UPDATED = 'CUSTOMER_PASSWORD_UPDATED',
  CUSTOMER_REGISTERED = 'CUSTOMER_REGISTERED',
  CUSTOMER_REMOVED_FROM_GROUP = 'CUSTOMER_REMOVED_FROM_GROUP',
  CUSTOMER_VERIFIED = 'CUSTOMER_VERIFIED',
  ORDER_CANCELLATION = 'ORDER_CANCELLATION',
  ORDER_COUPON_APPLIED = 'ORDER_COUPON_APPLIED',
  ORDER_COUPON_REMOVED = 'ORDER_COUPON_REMOVED',
  ORDER_CUSTOMER_UPDATED = 'ORDER_CUSTOMER_UPDATED',
  ORDER_FULFILLMENT = 'ORDER_FULFILLMENT',
  ORDER_FULFILLMENT_TRANSITION = 'ORDER_FULFILLMENT_TRANSITION',
  ORDER_MODIFIED = 'ORDER_MODIFIED',
  ORDER_NOTE = 'ORDER_NOTE',
  ORDER_PAYMENT_TRANSITION = 'ORDER_PAYMENT_TRANSITION',
  ORDER_REFUND_TRANSITION = 'ORDER_REFUND_TRANSITION',
  ORDER_STATE_TRANSITION = 'ORDER_STATE_TRANSITION'
}

/** Operators for filtering on a list of ID fields */
export type IdListOperators = {
  inList: Scalars['ID']['input'];
};

/** Operators for filtering on an ID field */
export type IdOperators = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * @description
 * Languages in the form of a ISO 639-1 language code with optional
 * region or script modifier (e.g. de_AT). The selection available is based
 * on the [Unicode CLDR summary list](https://unicode-org.github.io/cldr-staging/charts/37/summary/root.html)
 * and includes the major spoken languages of the world and any widely-used variants.
 *
 * @docsCategory common
 */
export enum LanguageCode {
  /** Afrikaans */
  Af = 'af',
  /** Akan */
  Ak = 'ak',
  /** Amharic */
  Am = 'am',
  /** Arabic */
  Ar = 'ar',
  /** Assamese */
  As = 'as',
  /** Azerbaijani */
  Az = 'az',
  /** Belarusian */
  Be = 'be',
  /** Bulgarian */
  Bg = 'bg',
  /** Bambara */
  Bm = 'bm',
  /** Bangla */
  Bn = 'bn',
  /** Tibetan */
  Bo = 'bo',
  /** Breton */
  Br = 'br',
  /** Bosnian */
  Bs = 'bs',
  /** Catalan */
  Ca = 'ca',
  /** Chechen */
  Ce = 'ce',
  /** Corsican */
  Co = 'co',
  /** Czech */
  Cs = 'cs',
  /** Church Slavic */
  Cu = 'cu',
  /** Welsh */
  Cy = 'cy',
  /** Danish */
  Da = 'da',
  /** German */
  De = 'de',
  /** Austrian German */
  De_AT = 'de_AT',
  /** Swiss High German */
  De_CH = 'de_CH',
  /** Dzongkha */
  Dz = 'dz',
  /** Ewe */
  Ee = 'ee',
  /** Greek */
  El = 'el',
  /** English */
  En = 'en',
  /** Australian English */
  En_AU = 'en_AU',
  /** Canadian English */
  En_CA = 'en_CA',
  /** British English */
  En_GB = 'en_GB',
  /** American English */
  En_US = 'en_US',
  /** Esperanto */
  Eo = 'eo',
  /** Spanish */
  Es = 'es',
  /** European Spanish */
  Es_ES = 'es_ES',
  /** Mexican Spanish */
  Es_MX = 'es_MX',
  /** Estonian */
  Et = 'et',
  /** Basque */
  Eu = 'eu',
  /** Persian */
  Fa = 'fa',
  /** Dari */
  Fa_AF = 'fa_AF',
  /** Fulah */
  Ff = 'ff',
  /** Finnish */
  Fi = 'fi',
  /** Faroese */
  Fo = 'fo',
  /** French */
  Fr = 'fr',
  /** Canadian French */
  Fr_CA = 'fr_CA',
  /** Swiss French */
  Fr_CH = 'fr_CH',
  /** Western Frisian */
  Fy = 'fy',
  /** Irish */
  Ga = 'ga',
  /** Scottish Gaelic */
  Gd = 'gd',
  /** Galician */
  Gl = 'gl',
  /** Gujarati */
  Gu = 'gu',
  /** Manx */
  Gv = 'gv',
  /** Hausa */
  Ha = 'ha',
  /** Hebrew */
  He = 'he',
  /** Hindi */
  Hi = 'hi',
  /** Croatian */
  Hr = 'hr',
  /** Haitian Creole */
  Ht = 'ht',
  /** Hungarian */
  Hu = 'hu',
  /** Armenian */
  Hy = 'hy',
  /** Interlingua */
  Ia = 'ia',
  /** Indonesian */
  Id = 'id',
  /** Igbo */
  Ig = 'ig',
  /** Sichuan Yi */
  Ii = 'ii',
  /** Icelandic */
  Is = 'is',
  /** Italian */
  It = 'it',
  /** Japanese */
  Ja = 'ja',
  /** Javanese */
  Jv = 'jv',
  /** Georgian */
  Ka = 'ka',
  /** Kikuyu */
  Ki = 'ki',
  /** Kazakh */
  Kk = 'kk',
  /** Kalaallisut */
  Kl = 'kl',
  /** Khmer */
  Km = 'km',
  /** Kannada */
  Kn = 'kn',
  /** Korean */
  Ko = 'ko',
  /** Kashmiri */
  Ks = 'ks',
  /** Kurdish */
  Ku = 'ku',
  /** Cornish */
  Kw = 'kw',
  /** Kyrgyz */
  Ky = 'ky',
  /** Latin */
  La = 'la',
  /** Luxembourgish */
  Lb = 'lb',
  /** Ganda */
  Lg = 'lg',
  /** Lingala */
  Ln = 'ln',
  /** Lao */
  Lo = 'lo',
  /** Lithuanian */
  Lt = 'lt',
  /** Luba-Katanga */
  Lu = 'lu',
  /** Latvian */
  Lv = 'lv',
  /** Malagasy */
  Mg = 'mg',
  /** Maori */
  Mi = 'mi',
  /** Macedonian */
  Mk = 'mk',
  /** Malayalam */
  Ml = 'ml',
  /** Mongolian */
  Mn = 'mn',
  /** Marathi */
  Mr = 'mr',
  /** Malay */
  Ms = 'ms',
  /** Maltese */
  Mt = 'mt',
  /** Burmese */
  My = 'my',
  /** Norwegian Bokmål */
  Nb = 'nb',
  /** North Ndebele */
  Nd = 'nd',
  /** Nepali */
  Ne = 'ne',
  /** Dutch */
  Nl = 'nl',
  /** Flemish */
  Nl_BE = 'nl_BE',
  /** Norwegian Nynorsk */
  Nn = 'nn',
  /** Nyanja */
  Ny = 'ny',
  /** Oromo */
  Om = 'om',
  /** Odia */
  Or = 'or',
  /** Ossetic */
  Os = 'os',
  /** Punjabi */
  Pa = 'pa',
  /** Polish */
  Pl = 'pl',
  /** Pashto */
  Ps = 'ps',
  /** Portuguese */
  Pt = 'pt',
  /** Brazilian Portuguese */
  Pt_BR = 'pt_BR',
  /** European Portuguese */
  Pt_PT = 'pt_PT',
  /** Quechua */
  Qu = 'qu',
  /** Romansh */
  Rm = 'rm',
  /** Rundi */
  Rn = 'rn',
  /** Romanian */
  Ro = 'ro',
  /** Moldavian */
  Ro_MD = 'ro_MD',
  /** Russian */
  Ru = 'ru',
  /** Kinyarwanda */
  Rw = 'rw',
  /** Sanskrit */
  Sa = 'sa',
  /** Sindhi */
  Sd = 'sd',
  /** Northern Sami */
  Se = 'se',
  /** Sango */
  Sg = 'sg',
  /** Sinhala */
  Si = 'si',
  /** Slovak */
  Sk = 'sk',
  /** Slovenian */
  Sl = 'sl',
  /** Samoan */
  Sm = 'sm',
  /** Shona */
  Sn = 'sn',
  /** Somali */
  So = 'so',
  /** Albanian */
  Sq = 'sq',
  /** Serbian */
  Sr = 'sr',
  /** Southern Sotho */
  St = 'st',
  /** Sundanese */
  Su = 'su',
  /** Swedish */
  Sv = 'sv',
  /** Swahili */
  Sw = 'sw',
  /** Congo Swahili */
  Sw_CD = 'sw_CD',
  /** Tamil */
  Ta = 'ta',
  /** Telugu */
  Te = 'te',
  /** Tajik */
  Tg = 'tg',
  /** Thai */
  Th = 'th',
  /** Tigrinya */
  Ti = 'ti',
  /** Turkmen */
  Tk = 'tk',
  /** Tongan */
  To = 'to',
  /** Turkish */
  Tr = 'tr',
  /** Tatar */
  Tt = 'tt',
  /** Uyghur */
  Ug = 'ug',
  /** Ukrainian */
  Uk = 'uk',
  /** Urdu */
  Ur = 'ur',
  /** Uzbek */
  Uz = 'uz',
  /** Vietnamese */
  Vi = 'vi',
  /** Volapük */
  Vo = 'vo',
  /** Wolof */
  Wo = 'wo',
  /** Xhosa */
  Xh = 'xh',
  /** Yiddish */
  Yi = 'yi',
  /** Yoruba */
  Yo = 'yo',
  /** Chinese */
  Zh = 'zh',
  /** Simplified Chinese */
  Zh_Hans = 'zh_Hans',
  /** Traditional Chinese */
  Zh_Hant = 'zh_Hant',
  /** Zulu */
  Zu = 'zu'
}

export enum LogicalOperator {
  AND = 'AND',
  OR = 'OR'
}

export type NativeAuthInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Operators for filtering on a list of Number fields */
export type NumberListOperators = {
  inList: Scalars['Float']['input'];
};

/** Operators for filtering on a Int or Float field */
export type NumberOperators = {
  between?: InputMaybe<NumberRange>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberRange = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

/** The smartform address suggestion input */
export type OracleInput = {
  /** The city. Used in conjunction with streetLine1 and postalCode to narrow the search. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The ISO 3166-1 alpha-2 country code. Only CZ and SK are supported. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The postal code. Used in conjunction with streetLine1 and city to narrow the search. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The street address. Used in conjunction with city and postalCode to narrow the search. */
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  /** Limits the number of results returned. Defaults to 21. */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The full address to search suggestions for, recommended to use this field instead of streetLine1, city and postalCode */
  wholeAddress?: InputMaybe<Scalars['String']['input']>;
};

export type OrderFilterParameter = {
  _and?: InputMaybe<Array<OrderFilterParameter>>;
  _or?: InputMaybe<Array<OrderFilterParameter>>;
  active?: InputMaybe<BooleanOperators>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  fioAccountNumber?: InputMaybe<StringOperators>;
  fioPaymentAmount?: InputMaybe<NumberOperators>;
  fioPaymentDate?: InputMaybe<DateOperators>;
  fioPaymentStatus?: InputMaybe<StringOperators>;
  fioSender?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  intermediatePaymentMethod?: InputMaybe<StringOperators>;
  orderPlacedAt?: InputMaybe<DateOperators>;
  shipping?: InputMaybe<NumberOperators>;
  shippingWithTax?: InputMaybe<NumberOperators>;
  state?: InputMaybe<StringOperators>;
  subTotal?: InputMaybe<NumberOperators>;
  subTotalWithTax?: InputMaybe<NumberOperators>;
  total?: InputMaybe<NumberOperators>;
  totalQuantity?: InputMaybe<NumberOperators>;
  totalWithTax?: InputMaybe<NumberOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type OrderListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<OrderFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<OrderSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  fioAccountNumber?: InputMaybe<SortOrder>;
  fioPaymentAmount?: InputMaybe<SortOrder>;
  fioPaymentDate?: InputMaybe<SortOrder>;
  fioPaymentStatus?: InputMaybe<SortOrder>;
  fioSender?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  intermediatePaymentMethod?: InputMaybe<SortOrder>;
  orderPlacedAt?: InputMaybe<SortOrder>;
  shipping?: InputMaybe<SortOrder>;
  shippingWithTax?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  subTotal?: InputMaybe<SortOrder>;
  subTotalWithTax?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalQuantity?: InputMaybe<SortOrder>;
  totalWithTax?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum OrderType {
  Aggregate = 'Aggregate',
  Regular = 'Regular',
  Seller = 'Seller'
}

export type PageFilterParameter = {
  _and?: InputMaybe<Array<PageFilterParameter>>;
  _or?: InputMaybe<Array<PageFilterParameter>>;
  content?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  position?: InputMaybe<NumberOperators>;
  rawContent?: InputMaybe<StringOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type PageListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<PageFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<PageSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PageSortParameter = {
  content?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  rawContent?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** Passed as input to the `addPaymentToOrder` mutation. */
export type PaymentInput = {
  /**
   * This field should contain arbitrary data passed to the specified PaymentMethodHandler's `createPayment()` method
   * as the "metadata" argument. For example, it could contain an ID for the payment and other
   * data generated by the payment provider.
   */
  metadata: Scalars['JSON']['input'];
  /** This field should correspond to the `code` property of a PaymentMethod. */
  method: Scalars['String']['input'];
};

/**
 * @description
 * Permissions for administrators and customers. Used to control access to
 * GraphQL resolvers via the {@link Allow} decorator.
 *
 * ## Understanding Permission.Owner
 *
 * `Permission.Owner` is a special permission which is used in some Vendure resolvers to indicate that that resolver should only
 * be accessible to the "owner" of that resource.
 *
 * For example, the Shop API `activeCustomer` query resolver should only return the Customer object for the "owner" of that Customer, i.e.
 * based on the activeUserId of the current session. As a result, the resolver code looks like this:
 *
 * @example
 * ```TypeScript
 * \@Query()
 * \@Allow(Permission.Owner)
 * async activeCustomer(\@Ctx() ctx: RequestContext): Promise<Customer | undefined> {
 *   const userId = ctx.activeUserId;
 *   if (userId) {
 *     return this.customerService.findOneByUserId(ctx, userId);
 *   }
 * }
 * ```
 *
 * Here we can see that the "ownership" must be enforced by custom logic inside the resolver. Since "ownership" cannot be defined generally
 * nor statically encoded at build-time, any resolvers using `Permission.Owner` **must** include logic to enforce that only the owner
 * of the resource has access. If not, then it is the equivalent of using `Permission.Public`.
 *
 *
 * @docsCategory common
 */
export enum Permission {
  /** Authenticated means simply that the user is logged in */
  Authenticated = 'Authenticated',
  /** Grants create Access Key */
  CreateAccessKey = 'CreateAccessKey',
  /** Grants permission to create Administrator */
  CreateAdministrator = 'CreateAdministrator',
  /** Grants permission to create Asset */
  CreateAsset = 'CreateAsset',
  /** Grants permission to create Products, Facets, Assets, Collections */
  CreateCatalog = 'CreateCatalog',
  /** Grants permission to create Channel */
  CreateChannel = 'CreateChannel',
  /** Grants permission to create ChannelCurrencySetting */
  CreateChannelCurrencySetting = 'CreateChannelCurrencySetting',
  /** Grants permission to create Collection */
  CreateCollection = 'CreateCollection',
  /** Grants permission to create Country */
  CreateCountry = 'CreateCountry',
  /** Grants permission to create Customer */
  CreateCustomer = 'CreateCustomer',
  /** Grants permission to create CustomerGroup */
  CreateCustomerGroup = 'CreateCustomerGroup',
  /** Grants permissions on email templates */
  CreateEmail = 'CreateEmail',
  /** Grants permission to create Facet */
  CreateFacet = 'CreateFacet',
  /** Grants create Import Access Key */
  CreateImportAccessKeys = 'CreateImportAccessKeys',
  /** Grants create Import Product Option Group */
  CreateImportProductOptionGroups = 'CreateImportProductOptionGroups',
  /** Grants permission to create Order */
  CreateOrder = 'CreateOrder',
  /** Grants permission to create PaymentMethod */
  CreatePaymentMethod = 'CreatePaymentMethod',
  /** Grants permission to create Product */
  CreateProduct = 'CreateProduct',
  /** Allows create profit information */
  CreateProfit = 'CreateProfit',
  /** Grants permission to create Promotion */
  CreatePromotion = 'CreatePromotion',
  /** Grants permission to create Seller */
  CreateSeller = 'CreateSeller',
  /** Grants permission to create PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  CreateSettings = 'CreateSettings',
  /** Grants permission to create ShippingMethod */
  CreateShippingMethod = 'CreateShippingMethod',
  /** Allows create static pages */
  CreateStaticPage = 'CreateStaticPage',
  /** Grants permission to create StockLocation */
  CreateStockLocation = 'CreateStockLocation',
  /** Grants permission to create System */
  CreateSystem = 'CreateSystem',
  /** Grants permission to create Tag */
  CreateTag = 'CreateTag',
  /** Grants permission to create TaxCategory */
  CreateTaxCategory = 'CreateTaxCategory',
  /** Grants permission to create TaxRate */
  CreateTaxRate = 'CreateTaxRate',
  /** Grants permission to create Zone */
  CreateZone = 'CreateZone',
  /** Grants delete Access Key */
  DeleteAccessKey = 'DeleteAccessKey',
  /** Grants permission to delete Administrator */
  DeleteAdministrator = 'DeleteAdministrator',
  /** Grants permission to delete Asset */
  DeleteAsset = 'DeleteAsset',
  /** Grants permission to delete Products, Facets, Assets, Collections */
  DeleteCatalog = 'DeleteCatalog',
  /** Grants permission to delete Channel */
  DeleteChannel = 'DeleteChannel',
  /** Grants permission to delete ChannelCurrencySetting */
  DeleteChannelCurrencySetting = 'DeleteChannelCurrencySetting',
  /** Grants permission to delete Collection */
  DeleteCollection = 'DeleteCollection',
  /** Grants permission to delete Country */
  DeleteCountry = 'DeleteCountry',
  /** Grants permission to delete Customer */
  DeleteCustomer = 'DeleteCustomer',
  /** Grants permission to delete CustomerGroup */
  DeleteCustomerGroup = 'DeleteCustomerGroup',
  /** Grants permissions on email templates */
  DeleteEmail = 'DeleteEmail',
  /** Grants permission to delete Facet */
  DeleteFacet = 'DeleteFacet',
  /** Grants delete Import Access Key */
  DeleteImportAccessKeys = 'DeleteImportAccessKeys',
  /** Grants delete Import Product Option Group */
  DeleteImportProductOptionGroups = 'DeleteImportProductOptionGroups',
  /** Grants permission to delete Order */
  DeleteOrder = 'DeleteOrder',
  /** Grants permission to delete PaymentMethod */
  DeletePaymentMethod = 'DeletePaymentMethod',
  /** Grants permission to delete Product */
  DeleteProduct = 'DeleteProduct',
  /** Allows delete profit information */
  DeleteProfit = 'DeleteProfit',
  /** Grants permission to delete Promotion */
  DeletePromotion = 'DeletePromotion',
  /** Grants permission to delete Seller */
  DeleteSeller = 'DeleteSeller',
  /** Grants permission to delete PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  DeleteSettings = 'DeleteSettings',
  /** Grants permission to delete ShippingMethod */
  DeleteShippingMethod = 'DeleteShippingMethod',
  /** Allows delete static pages */
  DeleteStaticPage = 'DeleteStaticPage',
  /** Grants permission to delete StockLocation */
  DeleteStockLocation = 'DeleteStockLocation',
  /** Grants permission to delete System */
  DeleteSystem = 'DeleteSystem',
  /** Grants permission to delete Tag */
  DeleteTag = 'DeleteTag',
  /** Grants permission to delete TaxCategory */
  DeleteTaxCategory = 'DeleteTaxCategory',
  /** Grants permission to delete TaxRate */
  DeleteTaxRate = 'DeleteTaxRate',
  /** Grants permission to delete Zone */
  DeleteZone = 'DeleteZone',
  /** Owner means the user owns this entity, e.g. a Customer's own Order */
  Owner = 'Owner',
  /** Public means any unauthenticated user may perform the operation */
  Public = 'Public',
  /** Grants read Access Key */
  ReadAccessKey = 'ReadAccessKey',
  /** Grants permission to read Administrator */
  ReadAdministrator = 'ReadAdministrator',
  /** Grants permission to read Asset */
  ReadAsset = 'ReadAsset',
  /** Grants permission to read Products, Facets, Assets, Collections */
  ReadCatalog = 'ReadCatalog',
  /** Grants permission to read Channel */
  ReadChannel = 'ReadChannel',
  /** Grants permission to read ChannelCurrencySetting */
  ReadChannelCurrencySetting = 'ReadChannelCurrencySetting',
  /** Grants permission to read Collection */
  ReadCollection = 'ReadCollection',
  /** Grants permission to read Country */
  ReadCountry = 'ReadCountry',
  /** Grants permission to read Customer */
  ReadCustomer = 'ReadCustomer',
  /** Grants permission to read CustomerGroup */
  ReadCustomerGroup = 'ReadCustomerGroup',
  /** Grants permissions on email templates */
  ReadEmail = 'ReadEmail',
  /** Grants permission to read Facet */
  ReadFacet = 'ReadFacet',
  /** Grants read Import Access Key */
  ReadImportAccessKeys = 'ReadImportAccessKeys',
  /** Grants read Import Product Option Group */
  ReadImportProductOptionGroups = 'ReadImportProductOptionGroups',
  /** Grants permission to read Order */
  ReadOrder = 'ReadOrder',
  /** Grants permission to read PaymentMethod */
  ReadPaymentMethod = 'ReadPaymentMethod',
  /** Grants permission to read Product */
  ReadProduct = 'ReadProduct',
  /** Allows read profit information */
  ReadProfit = 'ReadProfit',
  /** Grants permission to read Promotion */
  ReadPromotion = 'ReadPromotion',
  /** Grants permission to read Seller */
  ReadSeller = 'ReadSeller',
  /** Grants permission to read PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  ReadSettings = 'ReadSettings',
  /** Grants permission to read ShippingMethod */
  ReadShippingMethod = 'ReadShippingMethod',
  /** Allows read static pages */
  ReadStaticPage = 'ReadStaticPage',
  /** Grants permission to read StockLocation */
  ReadStockLocation = 'ReadStockLocation',
  /** Grants permission to read System */
  ReadSystem = 'ReadSystem',
  /** Grants permission to read Tag */
  ReadTag = 'ReadTag',
  /** Grants permission to read TaxCategory */
  ReadTaxCategory = 'ReadTaxCategory',
  /** Grants permission to read TaxRate */
  ReadTaxRate = 'ReadTaxRate',
  /** Grants permission to read Zone */
  ReadZone = 'ReadZone',
  /** SuperAdmin has unrestricted access to all operations */
  SuperAdmin = 'SuperAdmin',
  /** Grants update Access Key */
  UpdateAccessKey = 'UpdateAccessKey',
  /** Grants permission to update Administrator */
  UpdateAdministrator = 'UpdateAdministrator',
  /** Grants permission to update Asset */
  UpdateAsset = 'UpdateAsset',
  /** Grants permission to update Products, Facets, Assets, Collections */
  UpdateCatalog = 'UpdateCatalog',
  /** Grants permission to update Channel */
  UpdateChannel = 'UpdateChannel',
  /** Grants permission to update ChannelCurrencySetting */
  UpdateChannelCurrencySetting = 'UpdateChannelCurrencySetting',
  /** Grants permission to update Collection */
  UpdateCollection = 'UpdateCollection',
  /** Grants permission to update Country */
  UpdateCountry = 'UpdateCountry',
  /** Grants permission to update Customer */
  UpdateCustomer = 'UpdateCustomer',
  /** Grants permission to update CustomerGroup */
  UpdateCustomerGroup = 'UpdateCustomerGroup',
  /** Grants permissions on email templates */
  UpdateEmail = 'UpdateEmail',
  /** Grants permission to update Facet */
  UpdateFacet = 'UpdateFacet',
  /** Grants permission to update GlobalSettings */
  UpdateGlobalSettings = 'UpdateGlobalSettings',
  /** Grants update Import Access Key */
  UpdateImportAccessKeys = 'UpdateImportAccessKeys',
  /** Grants update Import Product Option Group */
  UpdateImportProductOptionGroups = 'UpdateImportProductOptionGroups',
  /** Grants permission to update Order */
  UpdateOrder = 'UpdateOrder',
  /** Grants permission to update PaymentMethod */
  UpdatePaymentMethod = 'UpdatePaymentMethod',
  /** Grants permission to update Product */
  UpdateProduct = 'UpdateProduct',
  /** Allows update profit information */
  UpdateProfit = 'UpdateProfit',
  /** Grants permission to update Promotion */
  UpdatePromotion = 'UpdatePromotion',
  /** Grants permission to update Seller */
  UpdateSeller = 'UpdateSeller',
  /** Grants permission to update PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  UpdateSettings = 'UpdateSettings',
  /** Grants permission to update ShippingMethod */
  UpdateShippingMethod = 'UpdateShippingMethod',
  /** Allows update static pages */
  UpdateStaticPage = 'UpdateStaticPage',
  /** Grants permission to update StockLocation */
  UpdateStockLocation = 'UpdateStockLocation',
  /** Grants permission to update System */
  UpdateSystem = 'UpdateSystem',
  /** Grants permission to update Tag */
  UpdateTag = 'UpdateTag',
  /** Grants permission to update TaxCategory */
  UpdateTaxCategory = 'UpdateTaxCategory',
  /** Grants permission to update TaxRate */
  UpdateTaxRate = 'UpdateTaxRate',
  /** Grants permission to update Zone */
  UpdateZone = 'UpdateZone',
  /** Grants access to the WooCommerce API authorize endpoint, which can be used to couple an app to an access key. */
  WooApiAllowAppLinking = 'WooApiAllowAppLinking'
}

export type PriceRangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductFilterParameter = {
  _and?: InputMaybe<Array<ProductFilterParameter>>;
  _or?: InputMaybe<Array<ProductFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  materialDescription?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  priceBeforeDiscount?: InputMaybe<NumberOperators>;
  reviewCount?: InputMaybe<NumberOperators>;
  reviewRating?: InputMaybe<NumberOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ProductListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductReviewFilterParameter = {
  _and?: InputMaybe<Array<ProductReviewFilterParameter>>;
  _or?: InputMaybe<Array<ProductReviewFilterParameter>>;
  authorLocation?: InputMaybe<StringOperators>;
  authorName?: InputMaybe<StringOperators>;
  body?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  downvotes?: InputMaybe<NumberOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  rating?: InputMaybe<NumberOperators>;
  state?: InputMaybe<StringOperators>;
  summary?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  upvotes?: InputMaybe<NumberOperators>;
};

export type ProductReviewListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductReviewFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductReviewSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductReviewSortParameter = {
  authorLocation?: InputMaybe<SortOrder>;
  authorName?: InputMaybe<SortOrder>;
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  downvotes?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  summary?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  upvotes?: InputMaybe<SortOrder>;
};

export enum ProductReviewState {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type ProductSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  materialDescription?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  priceBeforeDiscount?: InputMaybe<SortOrder>;
  reviewCount?: InputMaybe<SortOrder>;
  reviewRating?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductVariantFilterParameter = {
  _and?: InputMaybe<Array<ProductVariantFilterParameter>>;
  _or?: InputMaybe<Array<ProductVariantFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  price?: InputMaybe<NumberOperators>;
  priceBeforeDiscount?: InputMaybe<NumberOperators>;
  priceWithTax?: InputMaybe<NumberOperators>;
  productId?: InputMaybe<IdOperators>;
  sku?: InputMaybe<StringOperators>;
  stockLevel?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  weight?: InputMaybe<NumberOperators>;
};

export type ProductVariantListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductVariantFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductVariantSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductVariantSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceBeforeDiscount?: InputMaybe<SortOrder>;
  priceWithTax?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  stockLevel?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
};

export type RegisterCustomerInput = {
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ReturnStatus {
  Delivered = 'Delivered',
  InProgress = 'InProgress',
  Shipped = 'Shipped'
}

export type SearchInput = {
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  facetValueFilters?: InputMaybe<Array<FacetValueFilterInput>>;
  groupByColors?: InputMaybe<Scalars['Boolean']['input']>;
  groupByProduct?: InputMaybe<Scalars['Boolean']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  popularityScore?: InputMaybe<Scalars['Float']['input']>;
  priceRange?: InputMaybe<PriceRangeInput>;
  priceRangeWithTax?: InputMaybe<PriceRangeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SearchResultSortParameter>;
  take?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type SearchResultSortParameter = {
  name?: InputMaybe<SortOrder>;
  popularityScore?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  sales?: InputMaybe<SortOrder>;
  updated?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Operators for filtering on a list of String fields */
export type StringListOperators = {
  inList: Scalars['String']['input'];
};

/** Operators for filtering on a String field */
export type StringOperators = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type SubPageFilterParameter = {
  _and?: InputMaybe<Array<SubPageFilterParameter>>;
  _or?: InputMaybe<Array<SubPageFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  position?: InputMaybe<NumberOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type SubPageListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<SubPageFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  show?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<SubPageSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SubPageSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/**
 * Input used to update an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDisputeProposalInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  refundResolution?: InputMaybe<UpdateProposalRefundResolutionInput>;
};

export type UpdateOrderCustomFieldsInput = {
  fioAccountNumber?: InputMaybe<Scalars['String']['input']>;
  fioPaymentAmount?: InputMaybe<Scalars['Int']['input']>;
  fioPaymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  fioPaymentStatus?: InputMaybe<Scalars['String']['input']>;
  fioSender?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  customFields?: InputMaybe<UpdateOrderCustomFieldsInput>;
};

export type UpdateProposalRefundResolutionInput = {
  /** Optional, TODO - it will be calculated automatically if not provided until we have more than one payment method */
  paymentId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteCustomerAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomerAddressMutation = { deleteCustomerAddress: { success: boolean } };

export type SuccessFragment = { success: boolean };

export type DisputeReasonEntryFragment = { name: string, type: DisputeType, value: DisputeReason };

export type CreateAssetsMutationVariables = Exact<{
  input: Array<CreateAssetInput> | CreateAssetInput;
}>;


export type CreateAssetsMutation = { createAssets: Array<{ id: string, type: AssetType, preview: string, source: string } | { errorCode: ErrorCode, message: string }> };

export type InvalidCredentialsErrorFragment = { errorCode: ErrorCode, message: string, authenticationError: string };

export type PaymentFragment = { id: string, method: string, amount: any, state: string, metadata?: any | null };

export type ErrorResult_ActiveDisputeProposalAlreadyExistError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_AlreadyLoggedInError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_CouponCodeExpiredError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_CouponCodeInvalidError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_CouponCodeLimitError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_CreateProductReviewError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_CustomerNotFoundError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_DisputeAlreadyExistError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_DisputeNotFoundError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_DisputeProposalStateTransitionError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_DisputeStateTransitionError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_EmailAddressConflictError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_GuestCheckoutError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_IdentifierChangeTokenExpiredError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_IdentifierChangeTokenInvalidError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_IneligiblePaymentMethodError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_IneligibleShippingMethodError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_InsufficientStockError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_InternalOracleError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_InvalidCredentialsError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_MimeTypeError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_MissingPasswordError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_NativeAuthStrategyError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_NegativeQuantityError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_NoActiveOrderError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_NotVerifiedError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_OrderHasNoValidFulfillmentsError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_OrderHasNotFulfillmentsError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_OrderInterceptorError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_OrderLimitError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_OrderLineNotFoundError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_OrderModificationError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_OrderPaymentStateError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_OrderStateTransitionError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_PasswordAlreadySetError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_PasswordResetTokenExpiredError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_PasswordResetTokenInvalidError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_PasswordValidationError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_PaymentDeclinedError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_PaymentFailedError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_ProductReviewAssetMimeTypeError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_UnsupportedCountryCodeError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_VerificationTokenExpiredError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResult_VerificationTokenInvalidError_Fragment = { errorCode: ErrorCode, message: string };

export type ErrorResultFragment = ErrorResult_ActiveDisputeProposalAlreadyExistError_Fragment | ErrorResult_AlreadyLoggedInError_Fragment | ErrorResult_CouponCodeExpiredError_Fragment | ErrorResult_CouponCodeInvalidError_Fragment | ErrorResult_CouponCodeLimitError_Fragment | ErrorResult_CreateProductReviewError_Fragment | ErrorResult_CustomerNotFoundError_Fragment | ErrorResult_DisputeAlreadyExistError_Fragment | ErrorResult_DisputeNotFoundError_Fragment | ErrorResult_DisputeProposalStateTransitionError_Fragment | ErrorResult_DisputeStateTransitionError_Fragment | ErrorResult_EmailAddressConflictError_Fragment | ErrorResult_GuestCheckoutError_Fragment | ErrorResult_IdentifierChangeTokenExpiredError_Fragment | ErrorResult_IdentifierChangeTokenInvalidError_Fragment | ErrorResult_IneligiblePaymentMethodError_Fragment | ErrorResult_IneligibleShippingMethodError_Fragment | ErrorResult_InsufficientStockError_Fragment | ErrorResult_InternalOracleError_Fragment | ErrorResult_InvalidCredentialsError_Fragment | ErrorResult_MimeTypeError_Fragment | ErrorResult_MissingPasswordError_Fragment | ErrorResult_NativeAuthStrategyError_Fragment | ErrorResult_NegativeQuantityError_Fragment | ErrorResult_NoActiveOrderError_Fragment | ErrorResult_NotVerifiedError_Fragment | ErrorResult_OrderHasNoValidFulfillmentsError_Fragment | ErrorResult_OrderHasNotFulfillmentsError_Fragment | ErrorResult_OrderInterceptorError_Fragment | ErrorResult_OrderLimitError_Fragment | ErrorResult_OrderLineNotFoundError_Fragment | ErrorResult_OrderModificationError_Fragment | ErrorResult_OrderPaymentStateError_Fragment | ErrorResult_OrderStateTransitionError_Fragment | ErrorResult_PasswordAlreadySetError_Fragment | ErrorResult_PasswordResetTokenExpiredError_Fragment | ErrorResult_PasswordResetTokenInvalidError_Fragment | ErrorResult_PasswordValidationError_Fragment | ErrorResult_PaymentDeclinedError_Fragment | ErrorResult_PaymentFailedError_Fragment | ErrorResult_ProductReviewAssetMimeTypeError_Fragment | ErrorResult_UnsupportedCountryCodeError_Fragment | ErrorResult_VerificationTokenExpiredError_Fragment | ErrorResult_VerificationTokenInvalidError_Fragment;

export type CouponCodeExpiredErrorFragment = { couponCode: string, errorCode: ErrorCode, message: string };

export type RemoveCouponCodeMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
}>;


export type RemoveCouponCodeMutation = { removeCouponCode?: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | null };

export type OrderFragment = { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null };

export type CustomerFragment = { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string };

export type OrderAddressFragment = { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null };

export type ShippingMethodFragment = { id: string, code: string, name: string, description: string };

export type OrderLineFragment = { id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } };

export type FulfillmentFragment = { id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> };

export type SurchargeFragment = { orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } };

export type AssetFragment = { id: string, preview: string, source: string, type: AssetType };

export type ProductOptionFragment = { id: string, code: string, name: string };

export type ProductOptionGroupFragment = { id: string, code: string, name: string };

export type FulfillmentLineFragment = { fulfillmentId: string, orderLineId: string, quantity: number };

export type SearchResultAssetFragment = { id: string, preview: string };

export type PriceRangeFragment = { min: any, max: any };

export type TransitionOrderToStateMutationVariables = Exact<{
  state: Scalars['String']['input'];
}>;


export type TransitionOrderToStateMutation = { transitionOrderToState?: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | { transitionError: string, fromState: string, toState: string, errorCode: ErrorCode, message: string } | null };

export type OrderStateTransitionErrorFragment = { transitionError: string, fromState: string, toState: string, errorCode: ErrorCode, message: string };

export type EligibleDisputeReasonsQueryVariables = Exact<{
  orderLineId: Scalars['ID']['input'];
}>;


export type EligibleDisputeReasonsQuery = { eligibleDisputeReasons?: Array<{ name: string, type: DisputeType, value: DisputeReason }> | null };

export type DetectIntentMutationVariables = Exact<{
  input: GcxDetectIntentRequest;
}>;


export type DetectIntentMutation = { detectIntent: { responseId?: string | null, sessionId: string, languageCode: LanguageCode, location: string, responseType?: GcxResponseType | null, allowCancellation?: boolean | null, queryResult?: { text?: string | null, triggerEvent?: string | null, transcript?: string | null, languageCode?: string | null, parameters?: any | null, webhookPayloads?: Array<any | null> | null, diagnosticInfo?: any | null, dtmf?: { digits?: string | null, finishDigit?: string | null } | null, responseMessages?: Array<{ payload?: any | null, channel?: string | null, text?: { text: Array<string> } | null, conversationSuccess?: { metadata?: any | null } | null } | null> | null, webhookStatuses?: Array<{ code?: number | null, message?: string | null, details?: Array<{ typeUrl?: string | null, value?: string | null } | null> | null } | null> | null, currentPage?: { displayName: string } | null, intent?: { displayName: string, name?: string | null, description?: string | null, priority?: number | null, isFallback?: boolean | null, labels?: any | null, parameters?: Array<{ id: string, entityType: string, isList?: boolean | null, redact?: boolean | null } | null> | null } | null, match?: { event?: string | null, parameters?: any | null, resolvedInput?: string | null, matchType?: GcxMatchType | null, confidence?: number | null, intent?: { displayName: string } | null } | null, sentimentAnalysisResult?: { score?: number | null, magnitude?: number | null } | null } | null } };

export type ActiveOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrderQuery = { activeOrder?: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | null };

export type PagesQueryVariables = Exact<{
  options?: InputMaybe<PageListOptions>;
}>;


export type PagesQuery = { pages: { totalItems: number, items: Array<{ id: string, name: string, slug: string, content: string }> } };

export type PageFragment = { id: string, name: string, slug: string, content: string };

export type SizeChartTableFragment = { columns: Array<string>, fixedColumns: Array<string>, sizesColumns: Array<string>, name: string, records: { cm: Array<Array<string>>, in: Array<Array<string>> } };

export type ProductQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductQuery = { product?: { id: string, name: string, slug: string, description: string, priceBeforeDiscount?: any | null, collections: Array<{ id: string, name: string, slug: string, breadcrumbs: Array<{ id: string, name: string, slug: string }> }>, facetValues: Array<{ id: string, name: string, code: string, count?: number | null, facet: { id: string, name: string, code: string } }>, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, variants: Array<{ id: string, sku: string, name: string, productId: string, priceBeforeDiscount?: any | null, stockLevel: string, price: any, currency: CurrencyCode, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, name: string, slug: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }> }>, optionGroups: Array<{ id: string, code: string, name: string, options: Array<{ id: string, code: string, name: string }> }>, reviewStats: { totalReviews: number, averageRating: number, ratingDistribution: Array<{ rating: number, count: number }> }, customFields?: { reviewCount?: number | null, reviewRating?: number | null } | null } | null };

export type ProductFragment = { id: string, name: string, slug: string, description: string, priceBeforeDiscount?: any | null, collections: Array<{ id: string, name: string, slug: string, breadcrumbs: Array<{ id: string, name: string, slug: string }> }>, facetValues: Array<{ id: string, name: string, code: string, count?: number | null, facet: { id: string, name: string, code: string } }>, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, variants: Array<{ id: string, sku: string, name: string, productId: string, priceBeforeDiscount?: any | null, stockLevel: string, price: any, currency: CurrencyCode, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, name: string, slug: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }> }>, optionGroups: Array<{ id: string, code: string, name: string, options: Array<{ id: string, code: string, name: string }> }>, reviewStats: { totalReviews: number, averageRating: number, ratingDistribution: Array<{ rating: number, count: number }> }, customFields?: { reviewCount?: number | null, reviewRating?: number | null } | null };

export type CollectionWithBreadcrumbsFragment = { id: string, name: string, slug: string, breadcrumbs: Array<{ id: string, name: string, slug: string }> };

export type FacetValueFragment = { id: string, name: string, code: string, count?: number | null };

export type FacetFragment = { id: string, name: string, code: string };

export type ProductVariantFragment = { id: string, sku: string, name: string, productId: string, priceBeforeDiscount?: any | null, stockLevel: string, price: any, currency: CurrencyCode, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, name: string, slug: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }> };

export type ProductReviewStatsFragment = { totalReviews: number, averageRating: number, ratingDistribution: Array<{ rating: number, count: number }> };

export type CollectionFragment = { id: string, name: string, slug: string };

export type CollectionBreadcrumbFragment = { id: string, name: string, slug: string };

export type SetOrderShippingMethodMutationVariables = Exact<{
  shippingMethodId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SetOrderShippingMethodMutation = { setOrderShippingMethod: { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | { errorCode: ErrorCode, message: string } };

export type SearchOptionFragment = { id: string, code: string, name: string };

export type ShowPageInSubPageFragment = { id: string, createdAt: any, updatedAt: any, show: boolean, page: { id: string, name: string, slug: string, content: string } };

export type SubPageFragment = { id: string, createdAt: any, updatedAt: any, name: string, slug: string, pages: Array<{ id: string, createdAt: any, updatedAt: any, show: boolean, page: { id: string, name: string, slug: string, content: string } }> };

export type ReviewsQueryVariables = Exact<{
  options?: InputMaybe<ProductReviewListOptions>;
}>;


export type ReviewsQuery = { productReviews: { totalItems: number, items: Array<{ authorLocation?: string | null, authorName: string, body?: string | null, createdAt: any, downvotes: number, id: string, rating: number, state: ProductReviewState, summary: string, upvotes: number, product: { id: string, name: string, slug: string }, productVariant?: { id: string, sku: string, name: string, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }> } | null, assets: Array<{ id: string, type: AssetType, preview: string, source: string, mimeType: string }> }> } };

export type ProductReviewFragment = { authorLocation?: string | null, authorName: string, body?: string | null, createdAt: any, downvotes: number, id: string, rating: number, state: ProductReviewState, summary: string, upvotes: number, product: { id: string, name: string, slug: string }, productVariant?: { id: string, sku: string, name: string, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }> } | null, assets: Array<{ id: string, type: AssetType, preview: string, source: string, mimeType: string }> };

export type SearchOptionGroupFragment = { id: string, code: string, name: string };

export type SearchProductVariantResultFragment = { id: string, sku: string, name: string, stockLevel: string, price: any, currency: CurrencyCode, customProductVariantMappings: { priceBeforeDiscount?: number | null }, featuredAsset?: { id: string, preview: string } | null, assets: Array<{ id: string, preview: string }>, options?: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }> | null };

export type OrderLimitErrorFragment = { maxItems: number, errorCode: ErrorCode, message: string };

export type InsufficientStockErrorFragment = { quantityAvailable: number, errorCode: ErrorCode, message: string, order: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } };

export type LoginMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LoginMutation = { login: { __typename: 'CurrentUser', id: string, identifier: string } | { __typename: 'InvalidCredentialsError', errorCode: ErrorCode, message: string, authenticationError: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'NotVerifiedError', errorCode: ErrorCode, message: string } };

export type CurrentUserFragment = { id: string, identifier: string };

export type DisputeProposalFragment = { id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, customer?: { id: string, firstName: string, lastName: string } | null, manager?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null };

export type SetOrderShippingAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type SetOrderShippingAddressMutation = { setOrderShippingAddress: { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } };

export type CreateStripePaymentIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateStripePaymentIntentMutation = { createStripePaymentIntent: string };

export type ChannelFragment = { id: string, currency: CurrencyCode };

export type AddItemToOrderMutationVariables = Exact<{
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type AddItemToOrderMutation = { addItemToOrder: { quantityAvailable: number, errorCode: ErrorCode, message: string, order: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } } | { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | { errorCode: ErrorCode, message: string } | { maxItems: number, errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } };

export type UpdateDisputeProposalMutationVariables = Exact<{
  input: UpdateDisputeProposalInput;
}>;


export type UpdateDisputeProposalMutation = { updateDisputeProposal: { id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, customer?: { id: string, firstName: string, lastName: string } | null, manager?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null } };

export type FacetsQueryVariables = Exact<{
  options?: InputMaybe<FacetListOptions>;
}>;


export type FacetsQuery = { facets: { totalItems: number, items: Array<{ id: string, name: string, code: string, values: Array<{ id: string, name: string, code: string, count?: number | null }> }> } };

export type SubPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubPageQuery = { subPage: { id: string, createdAt: any, updatedAt: any, name: string, slug: string, pages: Array<{ id: string, createdAt: any, updatedAt: any, show: boolean, page: { id: string, name: string, slug: string, content: string } }> } };

export type CreateCustomerAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type CreateCustomerAddressMutation = { createCustomerAddress: { id: string, fullName?: string | null, company?: string | null, streetLine1: string, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, defaultShippingAddress?: boolean | null, defaultBillingAddress?: boolean | null, phoneNumber?: string | null, createdAt: any, country: { id: string, name: string, code: string } } };

export type AddressFragment = { id: string, fullName?: string | null, company?: string | null, streetLine1: string, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, defaultShippingAddress?: boolean | null, defaultBillingAddress?: boolean | null, phoneNumber?: string | null, createdAt: any, country: { id: string, name: string, code: string } };

export type CountryFragment = { id: string, name: string, code: string };

export type PasswordValidationErrorFragment = { validationErrorMessage: string, errorCode: ErrorCode, message: string };

export type SearchProductResultFragment = { id: string, name: string, slug: string, description: string, currency: CurrencyCode, customProductMappings: { materialDescription?: string | null, priceBeforeDiscountMax?: number | null, priceBeforeDiscountMin?: number | null, reviewCount: number, reviewRating: number }, collections: Array<{ id: string, name: string, slug: string, breadcrumbs: Array<{ id: string, name: string, slug: string }> }>, facetValues: Array<{ id: string, name: string, code: string, count?: number | null, facet: { id: string, name: string, code: string } }>, featuredAsset?: { id: string, preview: string } | null, assets: Array<{ id: string, preview: string }>, variants: Array<{ id: string, sku: string, name: string, stockLevel: string, price: any, currency: CurrencyCode, customProductVariantMappings: { priceBeforeDiscount?: number | null }, featuredAsset?: { id: string, preview: string } | null, assets: Array<{ id: string, preview: string }>, options?: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }> | null }>, optionGroups: Array<{ id: string, code: string, name: string, options?: Array<{ id: string, code: string, name: string }> | null }> };

export type GuestCheckoutErrorFragment = { errorDetail: string, errorCode: ErrorCode, message: string };

export type DisputeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisputeQuery = { dispute: { id: string, reason: DisputeReason, state: DisputeState, verdict?: DisputeVerdict | null, escalationLevel: DisputeEscalationLevel, createdAt: any, updatedAt: any, disputeLine: { id: string, quantity: number, orderLine: { id: string, order: { currencyCode: CurrencyCode }, productVariant: { id: string, name: string, options: Array<{ id: string, code: string, name: string }>, product: { id: string, name: string, slug: string } } } }, proposals: Array<{ id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, customer?: { id: string, firstName: string, lastName: string } | null, manager?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null }> } };

export type DisputeFragment = { id: string, reason: DisputeReason, state: DisputeState, verdict?: DisputeVerdict | null, escalationLevel: DisputeEscalationLevel, createdAt: any, updatedAt: any, disputeLine: { id: string, quantity: number, orderLine: { id: string, order: { currencyCode: CurrencyCode }, productVariant: { id: string, name: string, options: Array<{ id: string, code: string, name: string }>, product: { id: string, name: string, slug: string } } } }, proposals: Array<{ id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, customer?: { id: string, firstName: string, lastName: string } | null, manager?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null }> };

export type DisputesQueryVariables = Exact<{
  options?: InputMaybe<DisputeListOptions>;
}>;


export type DisputesQuery = { disputes: { totalItems: number, items: Array<{ id: string, reason: DisputeReason, state: DisputeState, verdict?: DisputeVerdict | null, escalationLevel: DisputeEscalationLevel, createdAt: any, updatedAt: any, disputeLine: { id: string, quantity: number, orderLine: { id: string, order: { currencyCode: CurrencyCode }, productVariant: { id: string, name: string, options: Array<{ id: string, code: string, name: string }>, product: { id: string, name: string, slug: string } } } }, proposals: Array<{ id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, customer?: { id: string, firstName: string, lastName: string } | null, manager?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null }> }> } };

export type AuthenticateMutationVariables = Exact<{
  input: AuthenticationInput;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AuthenticateMutation = { authenticate: { __typename: 'CurrentUser', id: string, identifier: string } | { __typename: 'InvalidCredentialsError', errorCode: ErrorCode, message: string } | { __typename: 'NotVerifiedError', errorCode: ErrorCode, message: string } };

export type OracleQueryVariables = Exact<{
  input: OracleInput;
}>;


export type OracleQuery = { oracle?: { errorCode: ErrorCode, message: string } | { suggestions: Array<{ fullAddress?: string | null, streetLine1?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null }> } | { errorCode: ErrorCode, message: string } | null };

export type OracleAddressSuggestionFragment = { fullAddress?: string | null, streetLine1?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null };

export type CollectionQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CollectionQuery = { collection?: { id: string, name: string, slug: string, parent?: { id: string, name: string, slug: string } | null, breadcrumbs: Array<{ id: string, name: string, slug: string }>, children?: Array<{ id: string, name: string, slug: string, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null }> | null } | null };

export type CollectionDetailFragment = { id: string, name: string, slug: string, breadcrumbs: Array<{ id: string, name: string, slug: string }>, children?: Array<{ id: string, name: string, slug: string, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null }> | null };

export type CollectionChildrenFragment = { children?: Array<{ id: string, name: string, slug: string, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null }> | null };

export type ApplyCouponCodeMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
}>;


export type ApplyCouponCodeMutation = { applyCouponCode: { couponCode: string, errorCode: ErrorCode, message: string } | { couponCode: string, errorCode: ErrorCode, message: string } | { couponCode: string, limit: number, errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } };

export type CouponCodeInvalidErrorFragment = { couponCode: string, errorCode: ErrorCode, message: string };

export type CouponCodeLimitErrorFragment = { couponCode: string, limit: number, errorCode: ErrorCode, message: string };

export type ActiveCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCustomerQuery = { activeCustomer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null };

export type AdjustOrderLineMutationVariables = Exact<{
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type AdjustOrderLineMutation = { adjustOrderLine: { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } };

export type SearchFacetValuesQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchFacetValuesQuery = { searchFacetValues: { totalItems: number, productFacets: Array<{ id: string, name: string, code: string, values: Array<{ id: string, name: string, code: string, count?: number | null }> }>, productVariantFacets: Array<{ id: string, name: string, code: string, values: Array<{ id: string, name: string, code: string, count?: number | null }> }> } };

export type VoteOnReviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  vote: Scalars['Boolean']['input'];
}>;


export type VoteOnReviewMutation = { voteOnReview: { authorLocation?: string | null, authorName: string, body?: string | null, createdAt: any, downvotes: number, id: string, rating: number, state: ProductReviewState, summary: string, upvotes: number, product: { id: string, name: string, slug: string }, productVariant?: { id: string, sku: string, name: string, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }> } | null, assets: Array<{ id: string, type: AssetType, preview: string, source: string, mimeType: string }> } };

export type AvailableCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCountriesQuery = { availableCountries: Array<{ id: string, name: string, code: string }> };

export type ProductsQueryVariables = Exact<{
  options?: InputMaybe<ProductListOptions>;
}>;


export type ProductsQuery = { products: { totalItems: number, items: Array<{ id: string, name: string, slug: string, facetValues: Array<{ id: string, name: string, code: string, count?: number | null, facet: { id: string, name: string, code: string } }>, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null }> } };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { updateCustomer: { __typename: 'Customer', id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } };

export type SubPagesQueryVariables = Exact<{
  options?: InputMaybe<SubPageListOptions>;
}>;


export type SubPagesQuery = { subPages: { totalItems: number, items: Array<{ id: string, createdAt: any, updatedAt: any, name: string, slug: string, pages: Array<{ id: string, createdAt: any, updatedAt: any, show: boolean, page: { id: string, name: string, slug: string, content: string } }> }> } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logout: { success: boolean } };

export type PaymentFailedErrorFragment = { paymentErrorMessage: string, errorCode: ErrorCode, message: string };

export type SearchProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SearchProductQuery = { searchProduct?: { id: string, name: string, slug: string, description: string, currency: CurrencyCode, customProductMappings: { materialDescription?: string | null, priceBeforeDiscountMax?: number | null, priceBeforeDiscountMin?: number | null, reviewCount: number, reviewRating: number }, collections: Array<{ id: string, name: string, slug: string, breadcrumbs: Array<{ id: string, name: string, slug: string }> }>, facetValues: Array<{ id: string, name: string, code: string, count?: number | null, facet: { id: string, name: string, code: string } }>, featuredAsset?: { id: string, preview: string } | null, assets: Array<{ id: string, preview: string }>, variants: Array<{ id: string, sku: string, name: string, stockLevel: string, price: any, currency: CurrencyCode, customProductVariantMappings: { priceBeforeDiscount?: number | null }, featuredAsset?: { id: string, preview: string } | null, assets: Array<{ id: string, preview: string }>, options?: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }> | null }>, optionGroups: Array<{ id: string, code: string, name: string, options?: Array<{ id: string, code: string, name: string }> | null }> } | null };

export type ActiveCustomerAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCustomerAddressesQuery = { activeCustomer?: { id: string, addresses?: Array<{ id: string, fullName?: string | null, company?: string | null, streetLine1: string, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, defaultShippingAddress?: boolean | null, defaultBillingAddress?: boolean | null, phoneNumber?: string | null, createdAt: any, country: { id: string, name: string, code: string } }> | null } | null };

export type RemoveAllOrderLinesMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveAllOrderLinesMutation = { removeAllOrderLines: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { __typename: 'CurrentUser', id: string, identifier: string } | null };

export type SetCustomerForOrderMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type SetCustomerForOrderMutation = { setCustomerForOrder: { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { errorDetail: string, errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } };

export type SearchResultPrice_PriceRange_Fragment = { min: any, max: any };

export type SearchResultPrice_SinglePrice_Fragment = { value: any };

export type SearchResultPriceFragment = SearchResultPrice_PriceRange_Fragment | SearchResultPrice_SinglePrice_Fragment;

export type SearchResultFragment = { productVariantId: string, score: number, slug: string, collectionIds: Array<string>, id: string, name: string, currency: CurrencyCode, featuredProductAsset?: { id: string, preview: string } | null, featuredProductVariantAsset?: { id: string, preview: string } | null, price: { min: any, max: any } | { value: any }, customProductMappings: { priceBeforeDiscountMin?: number | null, priceBeforeDiscountMax?: number | null, materialDescription?: string | null }, customProductVariantMappings: { priceBeforeDiscount?: number | null } };

export type CollectionListItemFragment = { position: number, id: string, name: string, slug: string, parent?: { id: string, name: string, slug: string } | null, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null };

export type PriceRangeBucketFragment = { count: number, to: number };

export type ActiveChannelQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveChannelQuery = { activeChannel: { id: string, currency: CurrencyCode } };

export type CollectionsQueryVariables = Exact<{
  options?: InputMaybe<CollectionListOptions>;
}>;


export type CollectionsQuery = { collections: { totalItems: number, items: Array<{ position: number, id: string, name: string, slug: string, parent?: { id: string, name: string, slug: string } | null, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null }> } };

export type PaymentMethodQuoteFragment = { id: string, code: string, name: string, description: string, isEligible: boolean, eligibilityMessage?: string | null };

export type RequestPasswordResetMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { requestPasswordReset?: { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } | null };

export type EligibleShippingMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type EligibleShippingMethodsQuery = { eligibleShippingMethods: Array<{ id: string, code: string, name: string, description: string, metadata?: any | null, price: any }> };

export type ShippingMethodQuoteFragment = { id: string, code: string, name: string, description: string, metadata?: any | null, price: any };

export type AddDisputeProposalMutationVariables = Exact<{
  input: AddDisputeProposalInput;
}>;


export type AddDisputeProposalMutation = { addDisputeProposal: { errorCode: ErrorCode, message: string } | { id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, customer?: { id: string, firstName: string, lastName: string } | null, manager?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null } };

export type ProductSizeChartTablesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductSizeChartTablesQuery = { productSizeChartTables: Array<{ columns: Array<string>, fixedColumns: Array<string>, sizesColumns: Array<string>, name: string, records: { cm: Array<Array<string>>, in: Array<Array<string>> } }> };

export type CreateProductReviewMutationVariables = Exact<{
  input: CreateProductReviewInput;
}>;


export type CreateProductReviewMutation = { createProductReview: { errorCode: ErrorCode, message: string } | { success: boolean } };

export type AddPaymentToOrderMutationVariables = Exact<{
  input: PaymentInput;
}>;


export type AddPaymentToOrderMutation = { addPaymentToOrder: { eligibilityCheckerMessage?: string | null, errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | { errorCode: ErrorCode, message: string } | { transitionError: string, fromState: string, toState: string, errorCode: ErrorCode, message: string } | { paymentErrorMessage: string, errorCode: ErrorCode, message: string } | { paymentErrorMessage: string, errorCode: ErrorCode, message: string } };

export type IneligiblePaymentMethodErrorFragment = { eligibilityCheckerMessage?: string | null, errorCode: ErrorCode, message: string };

export type PaymentDeclinedErrorFragment = { paymentErrorMessage: string, errorCode: ErrorCode, message: string };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword: { __typename: 'CurrentUser', id: string, identifier: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'NotVerifiedError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordResetTokenExpiredError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordResetTokenInvalidError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordValidationError', validationErrorMessage: string, errorCode: ErrorCode, message: string } };

export type RejectDisputeProposalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RejectDisputeProposalMutation = { rejectDisputeProposal: { id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, customer?: { id: string, firstName: string, lastName: string } | null, manager?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null } };

export type VerifyCustomerAccountMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyCustomerAccountMutation = { verifyCustomerAccount: { __typename: 'CurrentUser', id: string, identifier: string } | { __typename: 'MissingPasswordError', errorCode: ErrorCode, message: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordAlreadySetError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordValidationError', validationErrorMessage: string, errorCode: ErrorCode, message: string } | { __typename: 'VerificationTokenExpiredError', errorCode: ErrorCode, message: string } | { __typename: 'VerificationTokenInvalidError', errorCode: ErrorCode, message: string } };

export type TagFragment = { id: string, value: string };

export type FacetValueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FacetValueQuery = { facet?: { id: string, code: string, name: string } | null };

export type RegisterCustomerAccountMutationVariables = Exact<{
  input: RegisterCustomerInput;
}>;


export type RegisterCustomerAccountMutation = { registerCustomerAccount: { __typename: 'MissingPasswordError', errorCode: ErrorCode, message: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordValidationError', validationErrorMessage: string, errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type IsEligibleToCreateDisputeQueryVariables = Exact<{
  orderLineId: Scalars['ID']['input'];
}>;


export type IsEligibleToCreateDisputeQuery = { isEligibleToCreateDispute: { isDisputed: boolean, isEligible: boolean } };

export type EligiblePaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type EligiblePaymentMethodsQuery = { eligiblePaymentMethods: Array<{ id: string, code: string, name: string, description: string, isEligible: boolean, eligibilityMessage?: string | null }> };

export type RefreshCustomerVerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RefreshCustomerVerificationMutation = { refreshCustomerVerification: { errorCode: ErrorCode, message: string } | { success: boolean } };

export type SetIntermediatePaymentMethodMutationVariables = Exact<{
  paymentMethodCode: Scalars['String']['input'];
}>;


export type SetIntermediatePaymentMethodMutation = { setIntermediatePaymentMethod: { eligibilityCheckerMessage?: string | null, errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } };

export type SetOrderBillingAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type SetOrderBillingAddressMutation = { setOrderBillingAddress: { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } };

export type RequestUpdateCustomerEmailAddressMutationVariables = Exact<{
  password: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
}>;


export type RequestUpdateCustomerEmailAddressMutation = { requestUpdateCustomerEmailAddress: { __typename: 'EmailAddressConflictError', errorCode: ErrorCode, message: string } | { __typename: 'InvalidCredentialsError', errorCode: ErrorCode, message: string, authenticationError: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type RemoveOrderLineMutationVariables = Exact<{
  orderLineId: Scalars['ID']['input'];
}>;


export type RemoveOrderLineMutation = { removeOrderLine: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } };

export type OrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderQuery = { order?: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | null };

export type CreateDisputeMutationVariables = Exact<{
  input: CreateDisputeInput;
}>;


export type CreateDisputeMutation = { createDispute: { errorCode: ErrorCode, message: string } | { id: string, reason: DisputeReason, state: DisputeState, verdict?: DisputeVerdict | null, escalationLevel: DisputeEscalationLevel, createdAt: any, updatedAt: any, order: { orderPlacedAt?: any | null, id: string }, disputeLine: { id: string, quantity: number, orderLine: { id: string } }, customer: { id: string, firstName: string, lastName: string, emailAddress: string, phoneNumber?: string | null }, proposals: Array<{ id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, manager?: { id: string, firstName: string, lastName: string } | null, customer?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null }> } | { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } | { errorCode: ErrorCode, message: string } };

export type FacetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FacetQuery = { facet?: { id: string, name: string, code: string, values: Array<{ id: string, name: string, code: string, count?: number | null }> } | null };

export type PageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PageQuery = { pageBySlug: { id: string, name: string, slug: string, content: string } };

export type SetOrderCustomFieldsMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type SetOrderCustomFieldsMutation = { setOrderCustomFields: { errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } };

export type ActiveCustomerOrdersQueryVariables = Exact<{
  search: OrderListOptions;
}>;


export type ActiveCustomerOrdersQuery = { activeCustomer?: { id: string, orders: { totalItems: number, items: Array<{ __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null }> } } | null };

export type UpdateCustomerEmailAddressMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UpdateCustomerEmailAddressMutation = { updateCustomerEmailAddress: { __typename: 'IdentifierChangeTokenExpiredError', errorCode: ErrorCode, message: string } | { __typename: 'IdentifierChangeTokenInvalidError', errorCode: ErrorCode, message: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type ProductReviewsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ProductReviewListOptions>;
}>;


export type ProductReviewsQuery = { product?: { reviews: { totalItems: number, items: Array<{ authorLocation?: string | null, authorName: string, body?: string | null, createdAt: any, downvotes: number, id: string, rating: number, state: ProductReviewState, summary: string, upvotes: number, product: { id: string, name: string, slug: string }, productVariant?: { id: string, sku: string, name: string, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }> } | null, assets: Array<{ id: string, type: AssetType, preview: string, source: string, mimeType: string }> }> } } | null };

export type UpdateCustomerPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UpdateCustomerPasswordMutation = { updateCustomerPassword: { __typename: 'InvalidCredentialsError', errorCode: ErrorCode, message: string, authenticationError: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordValidationError', validationErrorMessage: string, errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type NextOrderStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type NextOrderStatesQuery = { nextOrderStates: Array<string> };

export type SearchQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchQuery = { search: { totalItems: number, prices: { range: { min: any, max: any }, buckets: Array<{ to: number, count: number }> }, items: Array<{ productVariantId: string, score: number, slug: string, collectionIds: Array<string>, id: string, name: string, currency: CurrencyCode, featuredProductAsset?: { id: string, preview: string } | null, featuredProductVariantAsset?: { id: string, preview: string } | null, price: { min: any, max: any } | { value: any }, customProductMappings: { priceBeforeDiscountMin?: number | null, priceBeforeDiscountMax?: number | null, materialDescription?: string | null }, customProductVariantMappings: { priceBeforeDiscount?: number | null } }>, facetValues: Array<{ count: number, facetValue: { id: string, name: string, code: string, count?: number | null, facet: { id: string, name: string, code: string } } }> } };

export type AcceptDisputeProposalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcceptDisputeProposalMutation = { acceptDisputeProposal: { id: string, state: DisputeProposalState, comment: string, createdAt: any, updatedAt: any, dispute: { id: string }, assets: Array<{ id: string, preview: string, source: string, type: AssetType }>, customer?: { id: string, firstName: string, lastName: string } | null, manager?: { id: string, firstName: string, lastName: string } | null, refundResolution?: { id: string, shipping: any, adjustment: any, payment: { id: string, method: string, amount: any, state: string, transactionId?: string | null, errorMessage?: string | null, refunds: Array<{ id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null }> }, refund?: { id: string, items: any, shipping: any, adjustment: any, total: any, method?: string | null, state: string, transactionId?: string | null, reason?: string | null, paymentId: string, metadata?: any | null, lines: Array<{ orderLineId: string, quantity: number, refundId: string }> } | null } | null } };

export type CreateComgatePaymentMutationVariables = Exact<{
  input?: InputMaybe<CreateComgatePaymentInput>;
}>;


export type CreateComgatePaymentMutation = { createComgatePayment: string };

export type UpdateCustomerAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateCustomerAddressMutation = { updateCustomerAddress: { id: string, fullName?: string | null, company?: string | null, streetLine1: string, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, defaultShippingAddress?: boolean | null, defaultBillingAddress?: boolean | null, phoneNumber?: string | null, createdAt: any, country: { id: string, name: string, code: string } } };

export type SearchPricesQueryVariables = Exact<{
  input: SearchInput;
}>;


export type SearchPricesQuery = { searchPrices: { totalItems: number, prices: { buckets: Array<{ count: number, to: number }>, range: { min: any, max: any } } } };

export type OrderByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type OrderByCodeQuery = { orderByCode?: { __typename: 'Order', id: string, code: string, active: boolean, createdAt: any, state: string, totalQuantity: number, orderPlacedAt?: any | null, couponCodes: Array<string>, currency: CurrencyCode, subTotal: any, shipping: any, total: any, taxSummary: Array<{ description: string, taxRate: number, taxTotal: any }>, customer?: { id: string, title?: string | null, firstName: string, lastName: string, phoneNumber?: string | null, emailAddress: string } | null, shippingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, billingAddress?: { fullName?: string | null, streetLine1?: string | null, streetLine2?: string | null, company?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, countryCode?: string | null, country?: string | null, phoneNumber?: string | null } | null, shippingLines: Array<{ price: any, discount: any, shippingMethod: { id: string, code: string, name: string, description: string }, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }> }>, lines: Array<{ id: string, quantity: number, unitPrice: any, linePrice: any, discountedUnitPrice: any, featuredAsset?: { id: string, preview: string, source: string, type: AssetType } | null, productVariant: { id: string, name: string, price: any, priceBeforeDiscount?: any | null, options: Array<{ id: string, code: string, name: string, group: { id: string, code: string, name: string } }>, product: { id: string, slug: string, name: string } } }>, payments?: Array<{ id: string, method: string, amount: any, state: string, metadata?: any | null }> | null, discounts: Array<{ adjustmentSource: string, type: AdjustmentType, description: string, amount: any }>, fulfillments?: Array<{ id: string, state: string, method: string, trackingCode?: string | null, lines: Array<{ fulfillmentId: string, orderLineId: string, quantity: number }> }> | null, surcharges: Array<{ orderLineId?: string | null, name: string, price: any, details: { icon?: string | null, position: number, tooltip?: string | null, description?: string | null, label: string } }>, customFields?: { intermediatePaymentMethod?: string | null } | null } | null };
